import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { SecureStorageObject } from '@ionic-native/secure-storage';
import { SecureStorageProvider } from '../secure-storage/secure-storage';
import { Platform, Events, AlertController, LoadingController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { LanguageProvider } from '../language/language';
import 'rxjs/add/observable/interval';
import { Device } from '../../../node_modules/@ionic-native/device';

declare var window;

@Injectable()
export class SettingsProvider {
  public AppVersion: string = window.AppVersion;
  public isForced: any;
  public islive: any;
  public AppName: string = window.AppName;
  public settings: any = {};
  public appVersion: any = null;
  public bankSettingData: any = {};
  public bankSettingsLoaded: boolean = false;
  public labelsData: any;
  public resultData: any = null;
  public languageString: "en";
  public isDev: boolean = window.isDev;// for development purpose to load data from json files
  public loading: any;
  sub: any;
  public app: any;
  public nav: any;
  sql_db: any;
  local_labelsData = {
    "web": {
      "WEB_CMN1": {
        "labels_en": {
          "WELCOME_TEXT1": "Welcome to Step One App",
          "NEW_CUSTOMER_BUTTON": "New Customer",
          "EXISTING_CUSTOMER_BUTTON": "Existing Customer",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_LOGIN": {
        "labels_en": {
          "WELCOME_TEXT1": "Welcome to Step One Online",
          "LOGIN_TEXT": "LOG IN",
          "REGISTER_BUTTON": "Register",
          "INSTRUCTION_1": "Email Address",
          "ERROR_TEXT1": "Please enter Email Address",
          "ERROR_TEXT2": "Please enter valid Email Address",
          "LOGIN_BUTTON": "Login",
          "SAVED_APPLICTION_BUTTON": "Open Saved Application",
          "IMPORTANT_TEXT": "This is our new platform. Existing customers will need to re-register to access their accounts by clicking \"Register\" below.",
          "INSTRUCTION_2": "Cookies On This Website",
          "INSTRUCTION_3": "To ensure our website functions properly and your information is kept secure, we use some essential cookies. By continuing to use our site you are acknowledging the use of all cookies.",
          "COOKIES_LINK_BUTTON": "here",
          "COOKIES_OK_BUTTON": "Ok",
          "Forgot_Button": "Forgot Pin/Password?",
          "INSTRUCTION_4": "You can find out more details on what .cookies we track",
          "ALERT_TITLE": "Alert",
          "ALERT_MESSAGE": "Something went wrong.",
          "ALERT_OK_BUTTON": "Ok",
          "PASSWORD_INSTRUCTION_1": "Your Online Pin",
          "PASSWORD_INSTRUCTION_2": "Enter the following numbers from your online pin",
          "PASSWORD_INSTRUCTION_3": "Please enter your Online Pin",
          "PASSWORD_INSTRUCTION_4": "Your Online Password",
          "PASSWORD_INSTRUCTION_5": "Enter the following characters from your online password",
          "PASSWORD_INSTRUCTION_6": "Please enter your Online Password",
          "PASSWORD_PREVIOUS_BUTTON": "Previous",
          "PASSWORD_SUBMIT_BUTTON": "Submit",
          "PIN_ALERT_TITLE": "Online Pin",
          "PIN_ALERT_MESSAGE": "Please enter Online Pin again",
          "PASSWORD_ALERT_TITLE": "Online Password",
          "PASSWORD_ALERT_MESSAGE": "Please enter Online Password again",
          "PASSWORD_ALERT_MESSAGE_1": "Incorrect Password, please try again",
          "PASSWORD_ALERT_MESSAGE_2": "Incorrect Pin & Password, please try again",
          "PASSWORD_ALERT_MESSAGE_3": "Incorrect Pin, please try again",
          "SHOW_PASSWORD_LABEL": "Show PIN & Password",
          "2FA_METHOD_TITLE": "Select 2FA Method",
          "MOBILE_OPTION_LABEL": "Mobile Number",
          "EMAIL_OPTION_LABEL": "Email Address",
          "OTP_TITLE": "OTP Passcode",
          "OTP_INSTRUCTION": "Enter OTP passcode",
          "VERIFY_BUTTON": "Verify",
          "REGISTRATION_PROMPT": "Have you already registered for our Mobile App?",
          "YES_BUTTON": "Yes",
          "NO_BUTTON": "No",
          "ALREADY_REGISTERED_PROMPT": "Already registered? Log in now",
          "VERIFICATION_OPTIONS_TITLE": "Please select one of the following to verify yourself",
          "VERIFICATION_PROMPT": "Please verify yourself to continue",
          "MOBILE_INPUT_LABEL": "Enter Mobile Number",
          "EMAIL_INPUT_LABEL": "Enter Email Address",
          "PASSCODE_SENT_MESSAGE": "We are sending you a 6 digit passcode for validation",
          "OTP_INPUT_LABEL": "Enter OTP Passcode",
          "OTP_TIMEOUT_MESSAGE": "Please enter your passcode within the next",
          "BUSINESS_HOURS_TITLE": "Business Hours",
          "PHONE_NUMBER": "01483 661 100",
          "CUSTOMER_SERVICE_EMAIL": "customerservice@steponefinance.co.uk",
          "SEND_PASSCODE_BUTTON": "Send Passcode",
          "RESEND_BUTTON": "Resend",
          "CONTACT_DETAILS_MISSING_TITLE": "Sorry, your contact details are missing in our records",
          "CONTACT_US_PROMPT": "Contact us below for more information",
          "OPENING_HOURS_TITLE": "Opening Hours",
          "CONTACT_US_LABEL": "Contact Us",
          "CONTACT_US_DAY1": "Monday - Friday",
          "CONTACT_US_TIME1": "09:00AM - 5:30PM",
          "CONTACT_US_DAY2": "Saturday - Sunday",
          "CONTACT_US_TIME2": "Closed",
          "CONTACT_US_DAY3": "Bank Holidays",
          "OTP_EXPIRED_MESSAGE": "OTP has expired. Please resend."
        }
      },
      "WEB_Register": {
        "labels_en": {
          "WELCOME_TEXT1": "Welcome to Step One Online",
          "NEW_CUSTOMER_BUTTON": "New Customer",
          "YES_BUTTON": "Yes",
          "NO_BUTTON": "No",
          "PREVIOUS_BUTTON": "Previous",
          "RESEND_BUTTON": "Resend",
          "CONTINUE_BUTTON": "Continue",
          "SEND_PASSCODE_BUTTON": "Send Passcode",
          "ALREADY_EXISTING_LINK_BUTTON": "Are you already registered ? Click here to Log in",
          "INSTRUCTION_1": "Have you already registered for our Mobile App?",
          "INSTRUCTION_2": "Enter Mobile Number",
          "INSTRUCTION_3": "A notification has been sent to the App registered with mobile number:",
          "INSTRUCTION_4": "Please enter the passcode below",
          "ERROR_TEXT1": "Please enter mobile number",
          "ERROR_TEXT2": "Please enter passcode",
          "ERROR_TEXT3": "Invalid Passcode",
          "ERROR_TEXT4": "Invalid mobile number",
          "ALERT_TITLE": "Alert",
          "ALERT_MESSAGE1": "something went wrong, please try again.",
          "ALERT_MESSAGE2": "You have reached the maximum number of attempts.",
          "ALERT_MESSAGE3": "unsuccessful attempts",
          "ALERT_MESSAGE4": "of 3",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_Verification": {
        "labels_en": {
          "WELCOME_TEXT1": "Welcome to Step One Online",
          "NEW_CUSTOMER_BUTTON": "New Customer",
          "PREVIOUS_BUTTON": "Previous",
          "RESEND_BUTTON": "Resend",
          "CONTINUE_BUTTON": "Continue",
          "SEND_PASSCODE_BUTTON": "Send Passcode",
          "ALREADY_EXISTING_LINK_BUTTON": "Are you already registered ? Click here to Log in",
          "INSTRUCTION_1": "Please select one of the following to verify yourself.",
          "INSTRUCTION_2": "Mobile Number",
          "INSTRUCTION_3": "Email Address",
          "INSTRUCTION_4": "Enter Email Address",
          "INSTRUCTION_5": "Enter Mobile Number",
          "INSTRUCTION_6": "We are sending you a 6 digit passcode for validation",
          "INSTRUCTION_7": "Enter Passcode",
          "INSTRUCTION_8": "Your passcode timed out. Click resend below.",
          "ERROR_TEXT1": "Please enter Email Address",
          "ERROR_TEXT2": "Please enter mobile number",
          "ERROR_TEXT3": "Please enter a correct mobile number",
          "ERROR_TEXT4": "Please enter a correct email address",
          "ERROR_TEXT5": "Please enter passcode",
          "ERROR_TEXT6": "Invalid Passcode",
          "ALERT_TITLE": "Alert",
          "ALERT_MESSAGE1": "something went wrong, please try again.",
          "ALERT_MESSAGE2": "You have reached the maximum number of attempts.",
          "ALERT_MESSAGE3": "unsuccessful attempts",
          "ALERT_MESSAGE4": "Please enter the passcode sent to you. You have ",
          "ALERT_MESSAGE5": " of 3 attempts. ",
          "ALERT_MESSAGE6": "You have reached the maximum number of attempts.",
          "ALERT_MESSAGE7": "Invalid Passcode",
          "ALERT_MESSAGE8": "unsuccessful attempts",
          "ALERT_MESSAGE9": "of 3",
          "ALERT_OK_BUTTON": "Ok",
          "TIMER_ALERT_MESSAGE": "Please enter your passcode within the next "
        }
      },
      "WEB_DOWNLOADS": {
        "labels_en": {
          "PAGE_TITLE": "Documents",
          "DASHBOARD_LABEL": "Dashboard",
          "BREADCRUMB_2": "Select Account",
          "INSTRUCTION_1": "Account Number",
          "VIEW_BUTTON": "View",
          "DOWNLOAD_DOCUMENTS_LABEL": "Documents",
          "CUSTOMER_DOCUMENTS_LABEL": "Customer Documents",
          "ACCOUNT_DOCUMENTS_LABEL": "Account Documents",
          "DOCUMENTS_HEADER": "Documents",
          "CUSTOMER_DOCUMENTS_HEADER": "Customer Documents",
          "ACCOUNT_DOCUMENTS_HEADER": "Account Documents",
          "DOWNLOAD_BUTTON": "Download",
          "BACK_BUTTON": "Back",
          "DOWNLOAD_STARTED": "Download started",
          "DOWNLOAD_FAILED": "Download failed",
          "NO_DOCUMENTS_AVAILABLE": "No documents available",
          "STATEMENT_LABEL_1": "Redemption Statement",
          "STATEMENT_LABEL_2": "Account Statement",
          "ERROR_LOADING_DOCUMENTS": "Error loading documents",
          "DOCUMENT_UNAVAILABLE": "Document currently unavailable"
        }
      },
      "WEB_NRC1": {
        "labels_en": {
          "WELCOME_TEXT": "Welcome to Step One Online",
          "INSTRUCTION_1": "Do you want to open account as ?",
          "SELF_BUTTON": "Sole",
          "JOIN_ACCOUNT_BUTTON": "Joint Account",
          "JUNIOR_ACCOUNT": "Junior Account",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "PREVIOUS_BUTTON": "Previous"
        }
      },
      "WEB_NCR2": {
        "labels_en": {
          "WELCOME_TEXT": "Welcome to Step One Online",
          "WELCOME_TEXT1": "Our accounts are only available to UK residents.",
          "WELCOME_TEXT2": "Please confirm you are a UK resident to proceed.",
          "CONFIRM_BUTTON": "Confirm",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "PREVIOUS_BUTTON": "Previous"
        }
      },
      "WEB_CMN2": {
        "labels_en": {
          "WELCOME_TEXT_1": "Online Terms and Conditions.",
          "WELCOME_TEXT_2": "Before you start using this you need to read and agree to our T&Cs.",
          "INSTRUCTION_1": "Step One Online Terms and Conditions",
          "INSTRUCTION_2": "FCA Statement",
          "INSTRUCTION_3": "Privacy Policy",
          "CONTINUE_BUTTON": "Continue",
          "AGREE_BUTTON": "Agree",
          "PREVIOUS_BUTTON": "Previous",
          "DOWNLOAD_BUTTON": "Download",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "This feature is currently disabled due to work in progress.",
          "ALERT_3": "Something went wrong.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_HOME": "Dashboard",
          "PAGE_TITLE": "Stepone Finance Online T&Cs"
        }
      },
      "WEB_CMN3": {
        "labels_en": {
          "INSTRUCTION_1": "Please enter your mobile number",
          "INSTRUCTION_2": "We are sending you a 6 digit passcode for mobile number validation",
          "ERROR_TEXT_1": "Please enter your mobile number",
          "ERROR_TEXT_2": "Please enter a correct mobile number",
          "CONTINUE_BUTTON": "Continue",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_CMN4": {
        "labels_en": {
          "INSTRUCTION_1": "Enter 6 Digit Passcode",
          "ERROR_TEXT_1": "Please enter a valid passcode",
          "INSTRUCTION_3": "Please enter your passcode within the next ${sec} seconds",
          "INSTRUCTION_4": "SMS code not received?",
          "RESEND_BUTTON": "Resend",
          "CONTINUE_BUTTON": "Continue",
          "ALERT_1": "Your mobile number has been\naccepted.",
          "ALERT_2": "Please enter the passcode sent to you via SMS",
          "ALERT_3": "Sorry, some error occurred Please try again.",
          "ALERT_4": "Please enter the passcode\n sent to you via SMS. You have made ATTEMPT of MAX_ATTEMPT attempts",
          "ALERT_5": "You have made max unsuccessful attempts",
          "ALERT_2_TITLE": "Invalid Passcode",
          "ALERT_CLOSE_BUTTON": "Close",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_NCR3": {
        "labels_en": {
          "PAGE_HEADING": "Products",
          "INSTRUCTION_1": "Please select an account type below.",
          "VIEW_BUTTON": "View",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Something went wrong please retry again",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "CONTINUE_BUTTON": "Continue"
        }
      },
      "WEB_NCR4": {
        "labels_en": {
          "PAGE_HEADING": "Sub Products",
          "VIEW_BUTTON": "View",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Something went wrong please retry again",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products"
        }
      },
      "WEB_NCR5": {
        "labels_en": {
          "PAGE_HEADING": "Product Features",
          "INSTRUCTION_1": "I have read all the documents regarding the products",
          "CONTINUE_BUTTON": "Continue",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Something went wrong please retry again",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_TITLE": "Alert",
          "ECAO_Confirmation_Alert_title": "Are you sure you wish to open this account?",
          "ECAO_Confirmation_Alert_Message": "",
          "ECAO_Confirmation_Alert_YES_BUTTON": "Yes",
          "ECAO_Confirmation_Alert_NO_BUTTON": "No",
          "AGREE_BUTTON": "Agree",
          "DOWNLOAD_BUTTON": "Download",
          "ISA_INSTRUCTION": "Accept the ISAs Product Terms & Condition.",
          "ISA_INSTRUCTION_1": "ISA Terms & Condition",
          "ISA_INSTRUCTION_2": "ISA Declaration"
        }
      },
      "WEB_NCR6A": {
        "labels_en": {
          "HEADING_1": "",
          "PAGE_HEADING": "Regular Frequency",
          "INSTRUCTION_1": "Amount *",
          "ERROR_TEXT_1": "Please enter amount",
          "INSTRUCTION_2": "Frequency *",
          "ERROR_TEXT_2": "Please select frequency",
          "INSTRUCTION_3": "Frequency number *",
          "ERROR_TEXT_3": "Please enter frequency number",
          "INSTRUCTION_4": "First Payment date *",
          "ERROR_TEXT_4": "Please enter payment date",
          "ERROR_TEXT_5": "Please enter correct payment date",
          "ERROR_TEXT_6": "Payment date must be a future date",
          "ERROR_TEXT_7": "Please enter Payment Date in the following format, dd-mm-yyyy",
          "CONTINUE_BUTTON": "Continue",
          "PREVIOUS_BUTTON": "Previous",
          "SAVE_BUTTON": "Save",
          "ALERT_1": "Your are not eligible for the product based on your age",
          "ALERT_2": "You are not eligible for the product based on your max account limit is complete",
          "ALERT_3": "Your are not eligible for the product based on your address postal code is not valid for this product",
          "ALERT_4": "You are not eligible for the product",
          "ALERT_5": "We cannot proceed with your request at this time, please contact the Customer Services Department to proceed",
          "ALERT_6": "Thank you for applying, please wait a minute and do not close or refresh browser",
          "ALERT_7": "Something went wrong please retry again",
          "ALER_8": "Sorry some error occurred, please try again",
          "MONTHLY_MIN_ERROR": "Amount is out of bounds",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "YEARS": "Years",
          "MONTHS": "Months",
          "DAYS": "Days",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "ERROR_TEXT_8": "Please enter valid amount",
          "ERROR_TEXT_9": "Please enter valid future date",
          "ECAO_Confirmation_Alert_title": "Are you sure you wish to open this account?",
          "ECAO_Confirmation_Alert_Message": "",
          "ECAO_Confirmation_Alert_YES_BUTTON": "Yes",
          "ECAO_Confirmation_Alert_NO_BUTTON": "No"
        }
      },
      "WEB_ALLBREADCRUMB": {
        "labels_en": {
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "BREADCRUMB_TITLE_5": "Personal Details",
          "BREADCRUMB_TITLE_6": "Address Details",
          "BREADCRUMB_TITLE_7": "Nominated Bank Account",
          "BREADCRUMB_TITLE_8": "Tax residency status"
        }
      },
      "WEB_NCR6": {
        "labels_en": {
          "PAGE_TITLE_2": "Application – Step 1 of 6",
          "PAGE_HEADING": "Origin of Funds",
          "HEADING_1": "Please give an indication of the amount of your initial deposit and the source of the funds",
          "INSTRUCTION_1": "Product",
          "INSTRUCTION_2": "Opening Deposit *",
          "INSTRUCTION_3": "Origin of Funds *",
          "INSTRUCTION_4": "How did you hear about us? *",
          "ERROR_TEXT_1": "Please enter opening deposit",
          "ERROR_TEXT_2": "Please enter origin of funds",
          "ERROR_TEXT_3": "Please select refrence origin",
          "ERROR_TEXT_4": "Please enter valid amount",
          "ERROR_TEXT_5": "Please enter valid origin of funds",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_1": "Something went wrong",
          "CONTINUE_BUTTON": "Continue",
          "PREVIOUS_BUTTON": "Previous",
          "SAVE_BUTTON": "Save",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "ECAO_Confirmation_Alert_title": "Are you sure you wish to open this account?",
          "ECAO_Confirmation_Alert_Message": "",
          "ECAO_Confirmation_Alert_YES_BUTTON": "Yes",
          "ECAO_Confirmation_Alert_NO_BUTTON": "No"
        }
      },
      "WEB_NRC7": {
        "labels_en": {
          "PAGE_HEADING": "Personal Details",
          "HEADING_1": "Personal details",
          "HEADING_2": "Personal details of 1st Account Holder",
          "HEADING_3": "Personal details of 2nd Account Holder",
          "HEADING_4": "of Child Applicant",
          "HEADING_5": "of Parent/Guardian",
          "INSTRUCTION_1": "Title *",
          "ERROR_TEXT_1": "Please select your Title",
          "INSTRUCTION_2": "First Name *",
          "ERROR_TEXT_2": "Please enter your First Name",
          "ERROR_TEXT_3": "First Name should not be more then 35 letters",
          "ERROR_TEXT_4": "Please enter correct First Name",
          "INSTRUCTION_3": "Middle Name",
          "ERROR_TEXT_5": "Middle Name should not be more then 35 letters",
          "ERROR_TEXT_6": "Please enter correct Middle Name",
          "INSTRUCTION_4": "Surname *",
          "ERROR_TEXT_7": "Please enter your Surname",
          "ERROR_TEXT_8": "Surname should not be more then 35 letters",
          "ERROR_TEXT_9": "Please enter correct Surname",
          "INSTRUCTION_5": "Date of Birth *",
          "ERROR_TEXT_10": "Please enter your Date of Birth",
          "INSTRUCTION_6": "National Insurance No. *",
          "ERROR_TEXT_11": "Please enter your National Insurance No",
          "ERROR_TEXT_12": "Please enter a correct National Insurance No.",
          "INSTRUCTION_7": "Email *",
          "ERROR_TEXT_13": "Please enter your Email",
          "ERROR_TEXT_14": "Please enter correct Email",
          "INSTRUCTION_8": "Nationality *",
          "ERROR_TEXT_15": "Please select your Nationality",
          "INSTRUCTION_9": "Country of Birth *",
          "ERROR_TEXT_16": "Please select your Country of Birth",
          "INSTRUCTION_10": "Please confirm “yes” or “no” if these details are correct",
          "ERROR_TEXT_17": "Date format should be dd-mm-yyyy in numbers",
          "ERROR_TEXT_18": "Your are not eligible for the product based on your age",
          "ERROR_TEXT_19": "You birth year must be greater than 1900",
          "ERROR_TEXT_20": "Please enter your Mobile Number",
          "ERROR_TEXT_21": "Date of birth cannot be greater than today's date",
          "ERROR_TEXT_22": "Please enter a valid age.",
          "ERROR_TEXT_23": "Your age must be less than ",
          "ERROR_TEXT_24": "Your age must be between ",
          "ERROR_TEXT_25": " and ",
          "ERROR_TEXT_26": " years old",
          "INSTRUCTION_11": "Mobile No. *",
          "INSTRUCTION_12": "Parents National Insurance No.",
          "NO_BUTTON": "No",
          "CONTINUE_BUTTON": "Continue",
          "PREVIOUS_BUTTON": "Previous",
          "SAVE_BUTTON": "Save",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Something went wrong",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "DATE_FORMAT_MESSAGE": "Please enter your Date of Birth in the following format, dd-mm-yyyy",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "BREADCRUMB_TITLE_5": "Personal Details"
        }
      },
      "WEB_NRC8": {
        "labels_en": {
          "PAGE_HEADING": "Address Details",
          "HEADING_1": "Current address",
          "HEADING_2": "Current address of 1st Account Holder",
          "HEADING_3": "Current address of 2nd Account Holder",
          "HEADING_4": "Work/Study Address",
          "HEADING_5": "of 1st Applicant",
          "HEADING_6": "of 2nd Applicant",
          "HEADING_7": " of Child Applicant",
          "HEADING_8": " of Parent/Guardian",
          "SEARCH_ADDRESS_CLOSE_BUTTON": "Close",
          "DATE_FORMAT_MESSAGE": "Please enter Move in Date in the following format, dd-mm-yyyy.",
          "PREVIOUS_BUTTON": "Previous",
          "SAVE_BUTTON": "Save",
          "INSTRUCTION_1": "Postcode *",
          "ERROR_TEXT_1": "Please enter Postcode",
          "ERROR_TEXT_2": "Please enter correct Postcode",
          "INSTRUCTION_2": "Select Address",
          "INSTRUCTION_3": "Address line 1 *",
          "ERROR_TEXT_4": "Please enter address line 1",
          "INSTRUCTION_4": "Address Line 2",
          "ERROR_TEXT_5": "Please enter address line 2",
          "INSTRUCTION_5": "Address Line 3",
          "ERROR_TEXT_6": "Please enter Address line 3",
          "INSTRUCTION_6": "Town/City *",
          "ERROR_TEXT_7": "Please enter Town/City",
          "INSTRUCTION_7": "County *",
          "ERROR_TEXT_8": "Please enter County",
          "INSTRUCTION_8": "Move in *",
          "INSTRUCTION_13": "Start Date *",
          "ERROR_TEXT_9": "Please enter move in date",
          "ERROR_TEXT_10": "Please enter valid date format dd-mm-yyyy in numbers",
          "INSTRUCTION_9": "Move out *",
          "ERROR_TEXT_11": "Please enter move out date",
          "ERROR_TEXT_12": "Please enter valid date format dd-mm-yyyy in numbers",
          "ERROR_TEXT_13": "Please enter valid date",
          "ADD_MORE_BUTTON": "Add more",
          "INSTRUCTION_10": "You have lived at your current address for less than 12 months. Please add your previous address(es).",
          "INSTRUCTION_11": "Please confirm Yes or No if these details are correct",
          "INSTRUCTION_12": "If you cannot remember the exact date you moved in then put the 1st of the month you moved in.",
          "NO_BUTTON": "No",
          "CONTINUE_BUTTON": "Continue",
          "NEXT_BUTTON": "Next",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "We were unable to find your post code. Please complete your address details below.",
          "ALERT_3": "Sorry postcode lookup service encountered an error. Please enter address manually.",
          "ALERT_4": "This product is only available to people living in the BA1 and BA2 postcode areas. If you are not living in these areas, please visit www.steponefinance.co.uk for more information.",
          "ALERT_TITLE": "Alert",
          "ALERT_TITLE_2": "Alert!",
          "ALERT_TITLE_3": "Unknown Post Code",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "BREADCRUMB_TITLE_5": "Personal Details",
          "BREADCRUMB_TITLE_6": "Address Details"
        }
      },
      "WEB_NRC13": {
        "labels_en": {
          "HEADING_1": "NBA Details",
          "PAGE_HEADING": "Nominated Bank Account",
          "HEADING_2": "Please provide details of your bank account.",
          "INSTRUCTION_1": "Sort Code *",
          "ERROR_TEXT_1": "Please enter your Sort Code",
          "ERROR_TEXT_2": "Please enter correct Sort code",
          "INSTRUCTION_2": "Account Number *",
          "ERROR_TEXT_3": "Please enter your Account Number",
          "ERROR_TEXT_4": "Please enter correct Account number",
          "INSTRUCTION_3": "Account Holder(s) *",
          "ERROR_TEXT_5": "Please enter the Account Holder name(s)",
          "ERROR_TEXT_6": "Please enter correct Account Holder name(s)",
          "INSTRUCTION_4": "Please confirm Continue if these details are correct",
          "INSTRUCTION_5": "Funds can only be sent to and from this bank account.",
          "NO_BUTTON": "No",
          "CONTINUE_BUTTON": "Continue",
          "PREVIOUS_BUTTON": "Previous",
          "SAVE_BUTTON": "Save",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "BREADCRUMB_TITLE_5": "Personal Details",
          "BREADCRUMB_TITLE_6": "Address Details",
          "BREADCRUMB_TITLE_7": "Nominated Bank Account"
        }
      },
      "WEB_NRC14": {
        "labels_en": {
          "HEADING_1": "Tax residency status",
          "PAGE_HEADING": "Tax residency status",
          "HEADING_2": "Are you a tax resident in another country other than the UK?",
          "UK_RESIDANT_BUTTON": "I am a UK tax resident only",
          "SELECT_COUNTRY_BUTTON": "I am not a UK tax resident",
          "CONTINUE_BUTTON": "Continue",
          "SAVE_BUTTON": "Save",
          "PREVIOUS_BUTTON": "Previous",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Please select at least one option",
          "ALERT_3": "Sorry your application is failed, please try again.",
          "ALERT_4": "Sorry our system is down, please try again.",
          "ALERT_5": "Sorry something went wrong, please contact to our nearest branch.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "THANK_YOU_APPLY_MESSAGE": "Thank you for applying, please wait a minute and do not close or refresh browser",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "Products",
          "BREADCRUMB_TITLE_3": "Regular Frequency",
          "BREADCRUMB_TITLE_4": "Origin of Funds",
          "BREADCRUMB_TITLE_5": "Personal Details",
          "BREADCRUMB_TITLE_6": "Address Details",
          "BREADCRUMB_TITLE_7": "Nominated Bank Account",
          "BREADCRUMB_TITLE_8": "Tax residency status"
        }
      },
      "WEB_NCR18": {
        "labels_en": {
          "PAGE_HEADING": "Unique ID Reference",
          "HEADING_1": "Your application has been approved.",
          "HEADING_2": "For security purposes your unique ID has been posted to you.",
          "HEADING_3": "When you receive the letter, please enter your unique ID and select Submit.",
          "HEADING_4": "Unique ID reference number",
          "SUBMIT_BUTTON": "Submit",
          "ALERT_1": "Please enter your Unique ID",
          "ALERT_2": "Please enter correct Unique ID",
          "ALERT_3": "Sorry, some error occurred Please try again.",
          "ALERT_4": "Please enter correct unique security code.unsuccessful attempts",
          "ALERT_5": "You have reached the maximum number of attempts.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_NCR19": {
        "labels_en": {
          "PAGE_HEADING": "Set Pin And Password",
          "HEADING_1": "Your User ID for online is ",
          "HEADING_2": "You will need to use this to login in the future.",
          "HEADING_3": "Please enter a Pin and Password so that you can login to Online Banking",
          "HEADING_4": "Want to use your own email address as user id?",
          "HEADING_5": "Set your own email address as user id.",
          "INSTRUCTION_1": "Set 6 digit PIN",
          "INSTRUCTION_2": "Confirm 6 digit PIN",
          "INSTRUCTION_3": "Your 6 digit pin should not have repetitive digits, ascending or descending numbers.",
          "INSTRUCTION_4": "Show Pin",
          "INSTRUCTION_5": "Set Password",
          "INSTRUCTION_6": "Confirm Password",
          "INSTRUCTION_7": "Your password should be of minimum 12 characters and should have at least one capital letter, one number and one special character.",
          "INSTRUCTION_8": "Show Password",
          "INSTRUCTION_9": "Enter Email Address",
          "INSTRUCTION_10": "Email Address",
          "INSTRUCTION_11": "Please enter the passcode below",
          "INSTRUCTION_12": "Passcode",
          "ERROR_TEXT_1": "Your 6 digit pin should not have repetitive digits, ascending or descending numbers.",
          "ERROR_TEXT_2": "Please enter pin.",
          "ERROR_TEXT_3": "Please enter confirm pin.",
          "ERROR_TEXT_4": "Pin length should be 6 digits",
          "ERROR_TEXT_5": "Pin and confirm pin do not match.",
          "ERROR_TEXT_6": "Please enter password.",
          "ERROR_TEXT_7": "Please enter confirm password.",
          "ERROR_TEXT_8": "Password length should be at least 12 characters",
          "ERROR_TEXT_9": "Confirm password length should be at least 12 characters",
          "ERROR_TEXT_10": "Invalid password. Password should contain 1 capital letter, 1 number and 1 special character.",
          "ERROR_TEXT_11": "Password and confirm password do not match.",
          "ERROR_TEXT_12": "Please enter Email Address",
          "ERROR_TEXT_13": "Invalid Email Address",
          "ERROR_TEXT_14": "Please enter passcode",
          "ERROR_TEXT_15": "Invalid Passcode",
          "ERROR_TEXT_16": "Require strong password policy: 1 Capital, 1 Number and 1 Special character",
          "TIMER_TEXT_1": "Please enter your passcode within the next ",
          "TIMER_TEXT_2": " seconds.",
          "TIMER_TEXT_3": "Your passcode timed out. Click resend below.",
          "PASSCODE_SEND_BUTTON": "Send Passcode",
          "BACK_BUTTON": "Back",
          "CONTINUE_BUTTON": "Continue",
          "RESEND_BUTTON": "Resend",
          "PREVIOUS_BUTTON": "Previous",
          "SUBMIT_BUTTON": "Submit",
          "ALERT_1": "Your Pin and Password set successfully.",
          "ALERT_2": "Sorry, some error occurred. Please try again.",
          "ALERT_TITLE_1": "Alert",
          "ALERT_TITLE_2": "Success",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_CLOSE_BUTTON": "Close",
          "PIN_PLACEHOLDER": "######",
          "PASSWORD_PLACEHOLDER": "############",
          "EMAIL_PLACEHOLDER": "Enter Email Address",
          "PASSCODE_PLACEHOLDER": "Enter Passcode"
        }
      },
      "WEB_NCR20": {
        "labels_en": {
          "HEADING_1": "Please enter your 6 digit login pin",
          "HEADING_2": "for 2 factor authentication",
          "INSTRUCTION_1": "Enter Pin",
          "INSTRUCTION_2": "Pin is required",
          "INSTRUCTION_3": "Pin Length is",
          "INSTRUCTION_5": "numbers",
          "LOGIN_BUTTON": "Login",
          "FORGET_PIN_BUTTON": "Forgot Pin?",
          "NEED_HELP_BUTTON": "Need Help?",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_2": "Enter correct 6 digit PIN",
          "ALERT_3": "Please enter a valid pin. You have used ATTEMPT of MAX_ATTEMPT attempts.",
          "ALERT_6": "Sorry, We are unable to find your data in app, please reinstall app again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_TWO_FACTOR": {
        "labels_en": {
          "WELCOME_TEXT": "Welcome to Step One Online",
          "HEADING_1": "2 Factor Authentication",
          "PARAGRAPH_1": "For security reason, please choose any below option to receive a 6 digit verification code to log in the app.",
          "PARAGRAPH_1B": "For security reason, please choose below option to receive a 6 digit verification code to log in the app.",
          "INSTRUCTION_1": "Text Message",
          "INSTRUCTION_2": "Email",
          "INSTRUCTION_3": "Please enter the passcode below",
          "PREVIOUS_BUTTON": "Previous",
          "CONTINUE_BUTTON": "Continue",
          "INSTRUCTION_4": "Phone Number.",
          "INSTRUCTION_5": "Email Address.",
          "PARAGRAPH_2": "Please enter the 6 digit verification code sent to your registered ",
          "ERROR_ALERT_TITLE_1": "Opps",
          "ERROR_ALERT_TITLE_2": "Alert",
          "ERROR_ALERT_MESSAGE_1": "Sorry, some error occurred Please try again.",
          "ERROR_ALERT_MESSAGE_2": "Please enter valid 2 factor authentication code",
          "ERROR_ALERT_OK_BUTTON": "Ok",
          "INSTRUCTION_6": "Access Blocked",
          "INSTRUCTION_7": "It seems that you are trying to login into already blocked customer account please contact us for more details.",
          "INSTRUCTION_8": "Please contact us. Our team will resolve data differences to allow application to proceed.",
          "INSTRUCTION_9": "01225 423271",
        }
      },
      "WEB_NCR20A": {
        "labels_en": {
          "HEADING_1": "2 Factor Authentication",
          "PARAGRAPH_1": "Please enter the 6 digit verification code sent on your registered",
          "PARAGRAPH_2": "mobile number",
          "PARAGRAPH_3": "email address",
          "INSTRUCTION_3": "Enter code",
          "SUBMIT_BUTTON": "Submit"
        }
      },
      "WEB_SAVED_APP": {
        "labels_en": {
          "WELCOME_TEXT": "Welcome to Step One Online",
          "HEADING_1": "Saved Application",
          "HEADING_2": "Received Unique ID",
          "INSTRUCTION_1": "Unique ID",
          "ERROR_TEXT_1": "Please enter Reference Number",
          "SUBMIT_BUTTON": "Submit",
          "LOGIN_BUTTON": "Login",
          "CONTINUE_BUTTON": "Continue",
          "PREVIOUS_BUTTON": "Previous"
        }
      },
      "WEB_ECR3": {
        "labels_en": {
          "PAGE_TITLE": "Existing Customer",
          "I_HAVE_REGISTER_BUTTON": "I have already registered",
          "I_HAVE_NOT_REGISTER_BUTTON": "I have not registered",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_ECR4": {
        "labels_en": {
          "PAGE_HEADING": "New Registration",
          "PAGE_HEADING2": "Resetting Login Details",
          "BREADCRUMB_TITLE_1": "Step One Online T&C",
          "BREADCRUMB_TITLE_2": "New Registration",
          "INSTRUCTION_1": "First Name *",
          "INSTRUCTION_2": "Last Name *",
          "INSTRUCTION_3": "Date of Birth *",
          "INSTRUCTION_5": "Email Address *",
          "INSTRUCTION_6": "Account Number *",
          "INSTRUCTION_6.1": "Account Number *",
          "INSTRUCTION_7": "Please enter your mortgage account number or the number at the top of your passbook.",
          "INSTRUCTION_8": "Last 4 digits of Account *",
          "INSTRUCTION_9": "Postal Code *",
          "INSTRUCTION_10": "Contact No*",
          "COMPANY_NAME": "Company Name *",
          "TELEPHONE": "Telephone Number *",
          "SIGNATORY_TRUSTEE_NAME": "Name of Signatory or Trustee",
          "ERROR_TEXT_1": "Please enter your first name",
          "ERROR_TEXT_2": "Please enter your last name",
          "ERROR_TEXT_3": "Please enter your date of birth",
          "ERROR_TEXT_4": "Date format should be dd-mm-yyyy in numbers",
          "ERROR_TEXT_5": "You must be 16 years old to register",
          "ERROR_TEXT_6": "Please enter your mobile no",
          "ERROR_TEXT_7": "Please enter your Email Address",
          "ERROR_TEXT_8": "Please enter your Step One's account number",
          "ERROR_TEXT_10": "Please enter your postal code",
          "ERROR_TEXT_11": "Please enter a valid postal code",
          "ERROR_TEXT_12": "Please enter registered mobile number",
          "ERROR_TEXT_13": "Please enter correct mobile number",
          "ERROR_TEXT_14": "Your birth year must be greater than 1900",
          "COMPANY_ERROR": "Please enter company name",
          "SIGNATORY_ERROR": "Please enter name of signatory or trustee",
          "CONTINUE_BUTTON": "Register",
          "PREVIOUS_BUTTON": "Previous",
          "RESET_PIN_BUTTON": "Reset Pin",
          "WELCOME_TEXT1": "We are now validating your registration details.",
          "WELCOME_TEXT2": "This process may take a few minutes",
          "DATE_FORMAT_MSG": "Please enter your Date of Birth in the following format: dd-mm-yyyy",
          "ALERT_1_TITLE": "Your response did not match our records.",
          "ALERT_2": "We have been unable to match your details. Please re-input your details ensuring that spellings/details exactly match your account details",
          "ALERT_3": "Sorry, some error occurred. Please try again.",
          "ALERT_4": "Please enter correct first name",
          "ALERT_5": "Please enter correct last name",
          "ALERT_6": "Sorry, some error occurred. Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_ECR5": {
        "labels_en": {
          "PAGE_HEADING": "Unique ID Reference",
          "WELCOME_TEXT1": "Thank you",
          "WELCOME_TEXT2": "For security purposes your unique ID has been emailed and posted to you.",
          "WELCOME_TEXT3": "When you receive the email or letter, please enter your unique ID and select Submit",
          "INSTRUCTION_1": "Unique ID number",
          "UNIQUE_ID_NOTE": "Note: Please be advised that this unique identifier will be a single-use code, not your loan ID.",
          "ERROR_TEXT_1": "Please enter your unique security code",
          "ERROR_TEXT_2": "Please enter correct unique security code",
          "SUBMIT_BUTTON": "Submit",
          "CONTINUE_BUTTON": "Continue",
          "ALERT_1": "Sorry, some error occurred Please try again",
          "ALERT_2": "Please enter your Unique ID number. You have made ATTEMPT of MAX_ATTEMPT attempts.",
          "ALERT_3": "Your unique ID was issued in your original registration letter. For security, to register your new number we need to confirm its you.",
          "ALERT_4": "Unique ID number accepted",
          "ALERT_5": "You have made max unsuccessful attempts",
          "ALERT_6": "Customer get blocked due to 3 unsuccessful attempts",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_ECRNP4": {
        "labels_en": {
          "WELCOME_TEXT1": "We will now register your new phone or new number",
          "WELCOME_TEXT2": "Please select one of the following",
          "I_HAVE_REGISTERED_NUMBER_BUTTON": "I have a registered number",
          "I_HAVE_NEW_NUMBER_BUTTON": "I am using a new number",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_NCRNP5": {
        "labels_en": {
          "PAGE_TITLE": "Active Pin Verification",
          "INSTRUCTION_1": "Enter your registered Mobile Number",
          "ERROR_TEXT_1": "Please enter your registered Mobile Number",
          "INSTRUCTION_2": "Enter your existing PIN",
          "ERROR_TEXT_2": "Please enter your existing PIN",
          "INSTRUCTION_3": "Forgotten PIN?",
          "VERIFY_BUTTON": "Verify",
          "ALERT_1": "<p class=\"alert-text-left\">The PIN entered does not match our records.</p><br><p class=\"alert-text-left\">Please try again or use the forgot PIN option.</p>",
          "ALERT_2": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_NCR21": {
        "labels_en": {
          "PAGE_NAME": "AccountsDocCheck",
          "STATUS_CODE": "New Customer Verification Documents Confirmation Check",
          "PAGE_TITLE": "",
          "HEADING_1": "Thank you for your application.",
          "HEADING_2": "We are currently unable to verify you electronically, therefore, please can you upload the following…",
          "INSTRUCTION_1": "To complete our ID requirements we need you to upload",
          "INSTRUCTION_2": "A current signed passport",
          "INSTRUCTION_3": "A current photocard driving license",
          "INSTRUCTION_4": "A selfie to confirm it's you",
          "INSTRUCTION_5": "Please Select To Confirm",
          "INSTRUCTION_6": "Please Select To Confirm",
          "INSTRUCTION_7": "To complete our ID requirements we need you to upload below documents of <b>1st Account Holder</b>",
          "INSTRUCTION_8": "To complete our ID requirements we need you to upload below documents of <b>2nd Account Holder</b>",
          "INSTRUCTION_9": "In order for us to proceed your application we require additional identification.",
          "INSTRUCTION_10": "Contact us for more information 01225 330014 .",
          "INSTRUCTION_11": "Opening Hours:",
          "INSTRUCTION_12": "Monday-Friday",
          "INSTRUCTION_13": "09 00 - 17 00",
          "INSTRUCTION_14": "Saturday",
          "INSTRUCTION_15": "09 00 - 13 00",
          "INSTRUCTION_16": "Sunday",
          "INSTRUCTION_17": "Closed",
          "INSTRUCTION_18": "We've sent you an email and a text message which will require actioning before proceeding with your application.",
          "INSTRUCTION_19": "Please follow the links provided in either the email or the text message to upload your documents.",
          "INSTRUCTION_20": "Additionally, we've sent you your Application Reference Number via email which you'll need to proceed with your application once we've processed your documents.",
          "INSTRUCTION_21": "Verification is successful.",
          "INSTRUCTION_22": "Document verification has been completed at the branch.",
          "INSTRUCTION_23": "Click on the continue button to proceed further.",
          "I_HAVE_DOCUMENTS_BUTTON": "Please can you send me a text message and an email to enable me to upload the relevant documents.",
          "HAVE_DOCUMENTS": "(full or provisional)",
          "I_DONT_HAVE_DOCUMENTS_BUTTON": "I don't have any of the above",
          "ALERT_1": "To proceed your request for new account opening, you need to submit your documents with Step One, kindly contact 01225 423271",
          "ALERT_2": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "CONTINUE_BUTTON": "Continue",
          "GO_BACK_BUTTON": "Go Back",
          "HOME_BUTTON": "Home"
        }
      },
      "WEB_NCR22": {
        "labels_en": {
          "PAGE_NAME": "",
          "STATUS_CODE": "",
          "PAGE_TITLE": "Upload Passport",
          "PAGE_TITLE2": "Upload Driving Licence",
          "HEADING_1": "Please take a picture of your Passport",
          "HEADING_6": "Please take a picture of your driving licence",
          "HEADING_2": "Example",
          "HEADING_3": "Use camera in landscape orientation",
          "HEADING_4": "We are now validating your identification details.",
          "HEADING_5": "This process may take a few minutes.",
          "PARAGRAPH": "To ensure your image is accepted please check that all text is clearly visible and there is no glare",
          "INSTRUCTION_1": "Thank you – This photo will be submitted for validation",
          "INSTRUCTION_2": "Do you want to use this photo ?",
          "INSTRUCTION_3": "Driving Licence Photo",
          "INSTRUCTION_4": "Thank you – This photo will be submitted for validation",
          "CONTINUE_BUTTON": "Continue",
          "RETAKE_BUTTON": "Retake",
          "USE_PHOTO_BUTTON": "Use Photo",
          "ALERT_1": "Please select image to upload",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_Accounts": {
        "labels_en": {
          "TAB_1": "Savings",
          "TAB_2": "Mortgages",
          "TAB_3": "External",
          "LABEL_1": "Account : ",
          "LABEL_2": "Balance : ",
          "LABEL_3": "Interest rate: ",
          "LABEL_4": "Your Fixed Rate savings account is approaching its maturity date. Please press <u>here</u> to view your options.",
          "LABEL_5": "Thank you for selecting your maturity option.",
          "TRANSACTION_STATUS_1": "In Process",
          "TRANSACTION_STATUS_2": "Pending",
          "TRANSACTION_STATUS_3": "Rejected",
          "TRANSACTION_STATUS_4": "Cleared",
          "LABEL_6": "View More Transactions",
          "LABEL_7": "Outstanding total balance : ",
          "LABEL_8": "Total monthly repayment : ",
          "LABEL_9": "Sub balance",
          "LABEL_10": "Account no :",
          "LABEL_11": "Sort Code : ",
          "LABEL_12": "Available :",
          "LABEL_13": "Remove",
          "LABEL_14": "You can add as many Credit Cards and Current Accounts as you like in order to help manage your finances",
          "LABEL_15": "ADD MORE ACCOUNTS",
          "LABEL_16": "ADD ACCOUNT / CARD",
          "LABEL_17": "No account found",
          "LABEL_18": "Please note, this is not a redemption figure",
          "RATE_NOW": "Rate now",
          "RATE_LATTER": "Remind later",
          "REDEMPTION_BUTTON": "Redemption figure",
          "REDEMPTION_NOTE": "Note: This is an approximate figure.",
          "REDEMPTION_AMOUNT": "Amount:",
          "REDEMPTION_TITLE": "Redemption Figure",
          "ALERT_1": "The account and any connections to savings and sweeper plans will be removed",
          "ALERT_2": "The account and any connections to savings plans will be removed",
          "ALERT_3": "The account and any connections to sweeper plans will be removed",
          "ALERT_4": "The account will be removed",
          "ALERT_5": "Account removed successfully",
          "ALERT_5_TITLE": "Account Removed",
          "ALERT_6": "Sorry, some error occurred Please try again.",
          "ALERT_7": "Sorry, We are unable to find your data in app, please reinstall app again.",
          "ALERT_8": "Would you like to rate our app?",
          "ALERT_8_TITLE": "Step One",
          "ALERT_9": "<p>Redemption Figure</p><h4>Amount:AMOUNT</h4><br/><p style='font-size:12px;'>Note: This is an approximate figure and may can vary</p>",
          "DAY_1": "Monday – Friday",
          "DAY_2": "Saturday",
          "TIME_1": "09:00 – 17:00",
          "TIME_2": "09:00 – 13:00",
          "CLOSE_DAY": "Sunday",
          "CLOSE": "Closed",
          "CONTACT_BUTTON": "Contact us",
          "HEADING_SAVINGS": "You Don't Currently Have<br/>Any Savings Products",
          "HEADING_MORTGAGE": "You Don't Currently Have<br/>Any Mortgage Products",
          "INSTRUCTION_1": "Contact us below<br/>for more information",
          "INSTRUCTION_2": "Opening hours:",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "BREADCRUMB_HOME": "Dashboard",
          "BREADCRUMB_1": "Mortgage Details",
          "MORTGAGE_LABEL_1": "Account Number",
          "MORTGAGE_LABEL_2": "Security Address",
          "MORTGAGE_LABEL_3": "Outstanding Balance",
          "MORTGAGE_LABEL_4": "Remaining Term",
          "MORTGAGE_LABEL_5": "Years",
          "MORTGAGE_LABEL_6": "Months",
          "MORTGAGE_LABEL_7": "Monthly Payment",
          "MORTGAGE_LABEL_8": "Payment Date",
          "MORTGAGE_LABEL_9": "Loan Details",
          "MORTGAGE_LABEL_10": "Product",
          "MORTGAGE_LABEL_11": "Pay Rate",
          "MORTGAGE_LABEL_12": "Product Ends",
          "MORTGAGE_LABEL_13": "Contact Us",
          "MORTGAGE_LABEL_14": "Standard Variable Rate",
          "MORTGAGE_LABEL_15": "View Product Ranges",
          "MORTGAGE_LABEL_16": "Accounts",
          "MORTGAGE_LABEL_17": "Repayment Type",
          "MORTGAGE_LABEL_18": "Current Pay Rate",
          "MORTGAGE_LABEL_19": "Current Product",
          "MORTGAGE_LABEL_20": "Redemption",
          "MORTGAGE_LABEL_21": "Outstanding Balance:",
          "MORTGAGE_LABEL_22": "Total Redemption Fees:",
          "MORTGAGE_LABEL_23": "Closing Fee",
          "MORTGAGE_LABEL_24": "Early Repayment Charges:",
          "MORTGAGE_LABEL_25": "Total Outstanding Balance",
          "MORTGAGE_LABEL_26": "Redemption Statement",
          "INSTRUCTION_4": "Please note, this is an estimate. please contact us should you wish to redeem",
          "Previous_Page": "Previous Page",
          "LABEL_19": "of",
          "Next_Page": "Next Page",
          "Acc_search_Error_Msg": "Please enter valid account number or account holder name.",
          "STATEMENT_LABEL_1": "Redumption Statement",
          "STATEMENT_LABEL_2": "Account Statement",
          "STATEMENT_LABEL_3": "Arrears Statement",
          "AGREEMENT_DATE_LABEL": "Agreement Date",
          "NEXT_PAYMENT_DATE_LABEL": "Next Payment Date",
          "FINAL_PAYMENT_DATE_LABEL": "Final Payment Date",
          "PAY_NOW_BUTTON": "Pay Now"
        }
      },
      "WEB_PROFILE": {
        "labels_en": {
          "BREADCRUMB_HOME": "Dashboard",
          "BREADCRUMB_UPDATE_PROFILE": "Update Profile",
          "PROFILE_TITLE": "Profile",
          "NAME_LABEL": "Your Name",
          "EMAIL_LABEL": "Email",
          "PHONE_LABEL": "Phone Number",
          "ADDRESS_LABEL": "Address",
          "UPDATE_NOTE": "Note: To update your contact details please get in touch with us using the below email address or phone number",
          "BUSINESS_HOURS_HEADING": "Business Hours",
          "CONTACT_PHONE": "01483 661 100",
          "CONTACT_EMAIL": "customerservice@steponefinance.co.uk",
          "UPDATE_PHONE_NUMBER_BUTTON": "Update Phone Number",
          "UPDATE_EMAIL_ADDRESS_BUTTON": "Update Email Address",
          "UPDATE_ADDRESS_BUTTON": "Update Address",
          "UPDATE_ADDRESS_HEADING": "Update Address",
          "UPDATE_ADDRESS_INSTRUCTION_1": "Post Code *",
          "UPDATE_ADDRESS_INSTRUCTION_2": "House Name/Number*",
          "UPDATE_ADDRESS_INSTRUCTION_3": "Street Name *",
          "UPDATE_ADDRESS_INSTRUCTION_4": "Address Line 3",
          "UPDATE_ADDRESS_INSTRUCTION_5": "City *",
          "UPDATE_ADDRESS_INSTRUCTION_6": "County *",
          "UPDATE_ADDRESS_INSTRUCTION_7": "Move in *",
          "UPDATE_ADDRESS_INSTRUCTION_8": "Country *",
          "UPDATE_ADDRESS_INSTRUCTION_9": "Please Select",
          "UPDATE_ADDRESS_SEARCH_BUTTON": "Search",
          "UPDATE_ADDRESS_SELECT_ADDRESS_HEADING": "Select Address",
          "HOME_BUTTON": "Home",
          "UPDATE_ADDRESS_CLOSE_BUTTON": "Close",
          "UPDATE_ADDRESS_CANCEL_BUTTON": "Cancel",
          "UPDATE_ADDRESS_SAVE_BUTTON": "Save",
          "CONTINUE_BUTTON": "Continue",
          "BACK_BUTTON": "Back",
          "UPDATE_ADDRESS_ERROR_TEXT_1": "Address not found for this postalcode.",
          "UPDATE_ADDRESS_ERROR_TEXT_2": "Please enter postalcode",
          "UPDATE_ADDRESS_ERROR_TEXT_3": "Complete address not found.",
          "UPDATE_ADDRESS_ERROR_TEXT_4": "Please enter your post code",
          "UPDATE_ADDRESS_ERROR_TEXT_5": "Please enter your House Name/Number",
          "UPDATE_ADDRESS_ERROR_TEXT_6": "Please enter your Street Name",
          "UPDATE_ADDRESS_ERROR_TEXT_7": "Please enter your city",
          "UPDATE_ADDRESS_ERROR_TEXT_8": "Please enter your county",
          "UPDATE_ADDRESS_ERROR_TEXT_9": "Please enter your country",
          "UPDATE_ADDRESS_ERROR_TEXT_10": "Please enter your move in date",
          "UPDATE_ADDRESS_ERROR_TEXT_11": "Please enter valid postcode",
          "ALERT_TITLE_1": "Alert",
          "ALERT_TITLE_2": "Success",
          "ALERT_OK_BUTTON": "Ok",
          "CONTACT_DETAILS_MISSING_TITLE": "Sorry, your contact details are missing in our records",
          "CONTACT_US_PROMPT": "Contact us below for more information",
          "OPENING_HOURS_TITLE": "Opening Hours",
          "CONTACT_US_LABEL": "Contact Us",
          "CONTACT_US_DAY1": "Monday - Friday",
          "CONTACT_US_TIME1": "09:00AM - 5:30PM",
          "CONTACT_US_DAY2": "Saturday - Sunday",
          "CONTACT_US_TIME2": "Closed",
          "CONTACT_US_DAY3": "Bank Holidays"
        }
      },
      "WEB_juniorExisting_main": {
        "labels_en": {
          "HEADING1": "Signatory Confirmation",
          "MESSAGE1": "Do you Want to add Parent/Guardian as Signatory?",
          "BUTTON_Y": "Yes",
          "BUTTON_N": "No",
          "BUTTON_P": "Previous",
          "BUTTON_C": "Continue",
          "HEADING2.1": "Child Confirmation",
          "HEADING2.2": "Parent Confirmation",
          "QUESTION1": "Want to create a new account for?",
          "QUESTION2": "Is your Parent/Guardian an existing Customer?",
          "OPTION1.1": "Existing Child",
          "OPTION1.2": "Existing Parent's/Guardian",
          "OPTION2.1": "New Child",
          "OPTION2.2": "New Parent's/Guardian"
        }
      },
      "WEB_juniorExisting_Origin": {
        "labels_en": {
          "HEADING1": "Origins of Funds",
          "BOX1": "Product",
          "BOX2": "Opening Deposit *",
          "BOX2_ER1": "Deposit can not be empty",
          "BOX2_ER2": "Minimum Deposit is 50",
          "BOX3": "Origin of Funds *",
          "BOX3_ER": "Origin can not be empty",
          "BOX4": "How did you hear about us?*",
          "BOX4_INST": "Please Select",
          "BOX4_ER": "Reference cannot be empty.",
          "BUTTON_B": "Back",
          "BUTTON_C": "Continue"
        }
      },
      "WEB_juniorExisting_NI": {
        "labels_en": {
          "HEADING1": "National Insurance Number of Parent/Guardian",
          "HEADING2": "National Insurance Number of Child",
          "INSTRUCTION": "Enter NI Number",
          "BUTTON_B": "Back",
          "BUTTON_C": "Continue"
        }
      },
      "WEB_juniorExisting_Search": {
        "labels_en": {
          "HEADING1": "Basic Details of Child ",
          "HEADING2": "Basic Details of Parent / Guardian",
          "BOX1": "First Name",
          "BOX2": "Last Name",
          "BOX3": "Date of Birth",
          "BOX4": "Postcode",
          "BOX5": "Account Number",
          "BUTTON_B": "Back",
          "BUTTON_C": "Continue",
          "BUTTON_P": "Previous"
        }
      },
      "WEB_juniorExisting_personal": {
        "labels_en": {
          "HEADING1": "Personal Details of Child ",
          "HEADING2": "Personal Details of Parent / Guardian",
          "BOX0": "Select Title *",
          "BOX0_ERR": "Title can not be empty",
          "BOX1": "First Name *",
          "BOX1_ERR1": "First Name cannot be empty",
          "BOX1_ERR2": "Please enter correct first name",
          "BOX1.1": "Middle Name",
          "BOX1.1_ERR": "Please enter correct Middle name",
          "BOX2": "Last Name *",
          "BOX2_ERR1": "Last Name cannot be empty",
          "BOX2_ERR2": "Please enter correct last name",
          "BOX3": "Date of Birth *",
          "BOX3_ERR": "Date of Birth cannot be empty",
          "BOX4": "Birth Country *",
          "BOX4_ERR": "Birth Country cannot be empty",
          "BOX5": "Nationality *",
          "BOX5_ERR": "Nationality cannot be empty",
          "BOX6": "Email *",
          "BOX6_ERR1": "Email cannot be empty",
          "BOX6_ERR2": "Please enter correct email address",
          "BOX7": "National Insurance Number*",
          "BOX7.1": "Parent's National Insurance Number*",
          "BOX7.2": "Child's National Insurance Number*",
          "BOX7_ERR1": "National Insurance Nummber can not be empty ",
          "BOX7_ERR2": "Please enter correct national insurance nummber",
          "BUTTON_B": "Previous",
          "BUTTON_C": "Continue"
        }
      },
      "WEB_juniorExisting_address": {
        "labels_en": {
          "HEADING1": "Address Details of Child ",
          "HEADING2": "Address Details of Parent / Guardian",
          "HEADING1.1": "Work Address Details of Child ",
          "HEADING2.2": "Work Address Details of Parent / Guardian",
          "BOX0": "Postal Code *",
          "BOX0_ERR1": "Postalcode not valid",
          "BOX0_ERR2": "Postalcode can not be empty",
          "BOX1": "Address 1 *",
          "BOX1_ERR": "Address 1 cannot be empty",
          "BOX1.1": "Address 2",
          "BOX1.2": "Address 3",
          "BOX2": "Town/City *",
          "BOX2_ERR": "Town/City cannot be empty",
          "BOX3": "County *",
          "BOX3_ERR": "County cannot be empty",
          "BOX4": "Move in Date *",
          "BOX4_ERR": "Move in Date cannot be empty",
          "BOX4_ERR1": "The move-in Date cannot be a future date.",
          "BUTTON_B": "Previous",
          "BUTTON_C": "Continue",
          "BUTTON_1": "Select Address",
          "BUTTON_CL": "CLOSE"
        }
      },
      "WEB_PAYUFUNDS": {
        "labels_en": {
          "HEADING1": "Great News!",
          "LINE1": "Your new account number is:",
          "LINE2": "Your account may take up to 48 hours to show on the accounts page.",
          "LINE3": "Paying in funds",
          "LINE4": "Electronic funds can be paid into your account using the following details.",
          "ACCOUNT_NAME": "Step One Building Society",
          "ACCOUNT_NUMBER": "00000000",
          "SORT_CODE": "62 30 45",
          "SUBHEADING1": "Sort Code:",
          "SUBHEADING2": "Account Number:",
          "SUBHEADING3": "Reference:",
          "SUBHEADING4": "Account Name",
          "LINE7": "Your reference must be quoted on all payments",
          "LINE8": "Paying out funds",
          "LINE9": "Please note: that you may have to set up your Nominated Bank Account with us before completing your first payment. To do this, please contact our Customer Service Department, or you can send a request via the 'UpdateBank Details' menu item.",
          "LINE10": "Please note: The Payee name that must be quoted is 'Step One Building Society' and you will need to select us as a business.",
          "LINE11": "Your account may take up to 48 hours to show on the accounts page.If you have indicated that you would like to invest in this Bond with funds from an eligible existing account held with us, we will be in contact by telephone within 3 business days.",
          "LINE12": "Electronic funds can be paid into your account using the following details.The below details relate to the Step One Building Society account at NatWest Bank in Step One.",
          "LINE13": "Please be aware that you can only make one deposit into this account."
        }
      },
      "WEB_UPDATEBANK_SETTINGS": {
        "labels_en": {
          "HEADING_1": "Nominated Bank Account",
          "SUB_HEADING_1": "Your Existing Details: ",
          "SUB_HEADING_2": "Account number: ",
          "SUB_HEADING_3": "Sort Code: ",
          "INSTRUCTION_1": "Please provide details of your new nominated bank account.",
          "INSTRUCTION_2": "Sort Code",
          "ERROR_TEXT_1": "Please Enter Sort Code ",
          "ERROR_TEXT_2": "Invalid SortCode",
          "INSTRUCTION_3": "Account Number",
          "ERROR_TEXT_3": "Please Enter Account Number",
          "ERROR_TEXT_4": "Invalid Account Number",
          "INSTRUCTION_4": "Account Holder(s) Name",
          "ERROR_TEXT_5": "Please Enter Account Holder(s) Name",
          "ERROR_TEXT_6": "Invalid Name",
          "INSTRUCTION_5": "Funds can only be sent to this bank account.",
          "UPDATE_BUTTON": "Update",
          "BREADCRUMB_HOME": "Home",
          "ALERT_TITLE_1": "Alert",
          "ALERT_TITLE_2": "Request Received",
          "ALERT_MESSAGE_1": "Sorry, some error occurred Please try again.",
          "ALERT_MESSAGE_2": "Your nominated account details will be updated within the next two working days.",
          "ALERT_MESSAGE_3": "Are you sure to continue?",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_CANCEL_BUTTON": "Cancel"
        }
      },
      "WEB_SETTINGS": {
        "labels_en": {
          "HEADING_1": "Settings",
          "INSTRUCTION_1": "Mobile Number",
          "INSTRUCTION_2": "Email Address",
          "INSTRUCTION_3": "Marketing Preferences",
          "INSTRUCTION_4": "Post",
          "INSTRUCTION_5": "Telephone",
          "INSTRUCTION_6": "Please confirm how you would like to be contacted. By selecting these boxes, you are agreeing to receive communications from us.",
          "INSTRUCTION_7": "Email",
          "INSTRUCTION_8": "SMS",
          "INSTRUCTION_9": "You can change your marketing preferences at any time using the options above.",
          "BREADCRUMB_HOME": "Home",
          "BREADCRUMB_SETTINGS": "Settings",
          "SAVE_BUTTON": "Save",
          "ALERT_TITLE": "Alert",
          "ALERT_TITLE_2": "Request Received",
          "ALERT_MESSAGE_1": "Sorry, some error occurred Please try again.",
          "ALERT_MESSAGE_2": "Are you sure to continue?",
          "ALERT_MESSAGE_3": "Your marketing preferences will be updated within the next two working days.",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_CANCEL_BUTTON": "Cancel"
        }
      },
      "WEB_BRANCHES": {
        "labels_en": {
          "PAGE_TITLE": "Visit a Branch",
          "INSTRUCTION_1": "Tel: ",
          "INSTRUCTION_2": "Opening Hours:",
          "VIEW_BUTTON": "View Details",
          "BREADCRUMB_HOME": "Home",
          "BREADCRUMB_1": "Our Branches",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_MESSAGES": {
        "labels_en": {
          "PAGE_TITLE": "Messages",
          "BREADCRUMB_HOME": "Home",
          "BREADCRUMB_1": "Messages",
          "BREADCRUMB_2": "Messages details",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_NEWS&BLOGS": {
        "labels_en": {
          "PAGE_TITLE": "News, Blogs & Social",
          "BREADCRUMB_HOME": "Home",
          "BREADCRUMB_1": "News, Blogs & Social",
          "BREADCRUMB_2": "News, Blogs & Social details",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok"
        }
      },
      "WEB_TRANSFER": {
        "labels_en": {
          "PAGE_TITLE": "Transfer",
          "DASHBOARD_LABEL": "Dashboard",
          "MORTGAGE_DETAILS_LABEL": "Mortgage Details",
          "MAKE_PAYMENT_LABEL": "Make Payment",
          "SELECT_ACCOUNT_LABEL": "Select Account",
          "SELECT_ACCOUNT_PLACEHOLDER": "Select From Account",
          "PLEASE_SELECT_LABEL": "Please Select",
          "INPUT_ACCOUNT_LABEL": "Account Number",
          "AMOUNT_LABEL": "Amount",
          "ENTER_AMOUNT_PLACEHOLDER": "Enter amount",
          "REFERENCE_LABEL": "Reference",
          "ENTER_REFERENCE_PLACEHOLDER": "Enter Reference",
          "MAKE_PAYMENT_BUTTON": "Make Payment",
          "ACCOUNT_CONFIRMATION_MESSAGE": "Please confirm that Account Number are correct before proceeding.",
          "PAYMENT_DETAILS_CONFIRMATION_MESSAGE": "Please confirm that the Payee, Sort Code and Account Number are correct before proceeding.",
          "CONTINUE_BUTTON": "Continue",
          "CONFIRM_BUTTON": "Confirm",
          "PAYMENTS_ACCEPT_TERMS": "I confirm that the card being used to make payment is in my name.",
          "MAKE_OTHER_BUTTON": "Make Another Transfer",
          "HOME_BUTTON": "Home",
          "BREADCRUMB_HOME": "Home",
          "BREADCRUMB_1": "Transfer",
          "BREADCRUMB_2": "Confirm Transfer",
          "BREADCRUMB_3": "Success",
          "ERROR_TEXT_1": "Please select different account",
          "ERROR_TEXT_2": "Please select to account",
          "ERROR_TEXT_3": "Please select from account",
          "ERROR_TEXT_4": "Please select to account",
          "ERROR_TEXT_5": "Please enter valid amount",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "ALERT_YES_BUTTON": "Yes",
          "ALERT_NO_BUTTON": "No",
          "ALERT_CONTINUE_BUTTON": "Continue",
          "ALERT_CANCEL_BUTTON": "Cancel",
          "ALERT_MESSAGE_1": "Are you sure you want to continue",
          "ALERT_MESSAGE_2": "Amount is required",
          "ALERT_MESSAGE_3": "Please select transfer to account",
          "ALERT_MESSAGE_4": "Please select transfer from account",
          "ALERT_MESSAGE_5": "Transfer between saving accounts details of customer ID ",
          "Acc_Modal_Instruction_1": "From",
          "Acc_Modal_Instruction_2": "To",
          "Acc_Modal_Instruction_3": "Balance:",
          "Acc_Modal_Instruction_4": "of",
          "Acc_Modal_Previous_Button": "Previous Page",
          "Acc_Modal_Next_Button": "Next Page",
          "Acc_Modal_Err_Instruction": "Please enter valid account number or account holder name.",
          "Acc_Modal_Confirm_Button": "Confirm",
          "ACC_PAYMENT_NOTE1": "<p>On this page you can make a maximum payment of <strong>£1000.00</strong> unless your monthly instalment figure is greater. If this is the case, you will be able to make a maximum of up to one month’s instalment value. </p> <p> Should you wish to make a payment larger than this, you can do so by either contacting us or using the below bank details. </p> <h3>Bank Details</h3> <ul> <li><strong>Account Number:</strong> [Insert Account Number]</li> <li><strong>Sort Code:</strong> [Insert Sort Code]</li> <li><strong>Reference:</strong> [Insert Reference]</li> </ul> <p> If you wish to repay your account in full, then a redemption statement will be required. This can be requested <a (click)=gotoRed_st()'>here</a>. </p> <p> <em>Please note:</em> For us to carry out our responsibilities under the <strong>Money Laundering Regulations 2007</strong>, for larger payments we may require to see the source of the funds. </p>",
          "ACC_PAYMENT_NOTE_CC": "Please be advised that payments via credit card will not be accepted.",
          "ACC_PAYMENT_NOTE_P1": "On this page you can make payments of up to <strong>£3,000.00</strong> in total per calendar month, unless your monthly instalment figure is greater. If this is the case, you will be able to make a single payment of one month’s instalment value.",
          "ACC_PAYMENT_NOTE_P2": "Should you wish to make a payment larger than this, you can do so by either contacting us or using the below bank details.",
          "ALERT_PAYMENT_TITLE": "Alert",
          "ALERT_PAYMENT_PAGE_ERROR": "Unable to open payment page",
          "ALERT_AMOUNT_TITLE": "Amount required",
          "ALERT_AMOUNT_MESSAGE": "Please enter a payment amount to continue.",
          "ALERT_OK": "OK",
          "ACC_PAYMENT_NOTE_HEADING_1": "Bank Details",
          "ACC_PAYMENT_NOTE_INSTRUCTION_H1": "STEP ONE FINANCE LIMITED",
          "ACC_PAYMENT_NOTE_INSTRUCTION_1": "Account Number",
          "ACC_PAYMENT_NOTE_INSTRUCTION_2": "Sort Code",
          "ACC_PAYMENT_NOTE_INSTRUCTION_3": "Reference",
          "ACC_PAYMENT_NOTE_INSTRUCTION_VALUE_1": "83352951",
          "ACC_PAYMENT_NOTE_INSTRUCTION_VALUE_2": "200000",
          "ACC_PAYMENT_NOTE_INSTRUCTION_VALUE_3": "Your Reference",
          "ACC_PAYMENT_NOTE_P3": "If you wish to repay your account in full, then a redemption statement will be required. This can be requested ",
          "ACC_PAYMENT_NOTE_LINK_1": "here",
          "ACC_PAYMENT_NOTE_P4": "<em>Please note:</em> For us to carry out our responsibilities under the <strong>Money Laundering Regulations 2007</strong>, for larger payments we may require to see the source of the funds.",
          "ACC_PAYMENT_NOTE_P5": "Rules",
          "ACC_PAYMENT_NOTE_RULE_1": "Borrowers can pay a maximum of £1000 unless the CMI is greater so this will need to be cross checked within the Consectus app.",
          "ACC_PAYMENT_NOTE_RULE_2": "If payment is successful, then please have a pop-up box stating, ‘Payment successful’ and navigate the customer to the homepage.",
          "ACC_PAYMENT_NOTE_RULE_3": "If a payment is unsuccessful, the customer should remain on the current make a payment page to allow a further payment attempt.",
          "ACC_PAYMENT_NOTE_RULE_4": "If a second successive payment is unsuccessful then a pop-up message should appear stating that the ‘Payment was unsuccessful, please contact us on 01483 661 100, our opening hours are Monday to Friday, 09:00-17:30)"
        }
      },
      "PROCESS_PAYMENT": {
        "labels_en": {
          "BREADCRUMB_1": "Home",
          "BREADCRUMB_2": "Make a Payment",
          "BREADCRUMB_3": "Process Payment",
          "ALERT1_TITLE_1": "Payment successful",
          "ALERT1_DESCRIPTION_1": "Your payment has been received.",
          "ALERT1_BUTTON_1": "OK",
          "ALERT2_TITLE_1": "Payment unsuccessful",
          "ALERT2_DESCRIPTION_1": "Your payment was not successful. No amount has been taken. Please try again.",
          "ALERT2_BUTTON_1": "OK",
          "ALERT3_TITLE_1": "Payment unsuccessful",
          "ALERT3_DESCRIPTION_1": "Payment was unsuccessful, please contact us on 01483 661 100. Our opening hours are Monday to Friday, 09:00-17:30.",
          "ALERT3_BUTTON_1": "OK",
        }
      },
      "WEB_CONTACTUS": {
        "labels_en": {
          "HEADING_1": "Help & Contact Us",
          "INSTRUCTION_1": "Help",
          "INSTRUCTION_2": "Contact Us",
          "INSTRUCTION_3": "Provide us your feedback",
          "INSTRUCTION_4": "Telephone",
          "INSTRUCTION_5": "If your query is not listed in our FAQs please contact us",
          "INSTRUCTION_6": "01225 475719",
          "INSTRUCTION_7": "Provide us your feedback",
          "INSTRUCTION_8": "Tell us more about your feedback",
          "INSTRUCTION_9": "Please call us on",
          "INSTRUCTION_10": "Savings",
          "INSTRUCTION_10a": "01225 423271",
          "INSTRUCTION_10b": "Mortgage Team",
          "INSTRUCTION_10c": "01225 475719",
          "INSTRUCTION_11": "Our opening hours:",
          "INSTRUCTION_12": "Monday to Friday: 9am - 5pm",
          "INSTRUCTION_13": "Business Hours:",
          "INSTRUCTION_14": "customerservice@steponefinance.co.uk",
          "VIEW_BUTTON": "View",
          "SUBMIT_BUTTON": "Submit",
          "BREADCRUMB_HOME": "Dashboard",
          "BREADCRUMB_1": "Help & Contact Us",
          "BREADCRUMB_2": "Feedback",
          "BREADCRUMB_3": "Telephone Details",
          "ERROR_TEXT_1": "Minimum 10 words required",
          "ALERT_1": "Sorry, some error occurred. Please try again.",
          "ALERT_2": "Thank you, your feedback was submitted successfully",
          "ALERT_TITLE_1": "Alert",
          "ALERT_TITLE_2": "Success",
          "ALERT_OK_BUTTON": "OK",
          "DAYS_MONDAY": "Monday",
          "DAYS_TUESDAY": "Tuesday",
          "DAYS_WEDNESDAY": "Wednesday",
          "DAYS_THURSDAY": "Thursday",
          "DAYS_FRIDAY": "Friday",
          "DAYS_SATURDAY": "Saturday",
          "DAYS_SUNDAY": "Sunday",
          "HOURS_CLOSED": "Closed",
          "CONTACT_US_PROMPT": "Contact us below for more information",
          "OPENING_HOURS_TITLE": "Opening Hours",
          "CONTACT_US_LABEL": "Contact Us",
          "CONTACT_US_DAY1": "Monday - Friday",
          "CONTACT_US_TIME1": "09:00AM - 5:30PM",
          "CONTACT_US_DAY2": "Saturday - Sunday",
          "CONTACT_US_TIME2": "Closed",
          "CONTACT_US_DAY3": "Bank Holidays",
          "BUSINESS_HOURS_HEADING": "Business Hours",
          "CONTACT_PHONE": "01483 661 100",
          "CONTACT_EMAIL": "customerservice@steponefinance.co.uk",
        }
      },
      "WEB_MORTGAGE_CALCULATOR": {
        "labels_en": {
          "INSTRUCTION_1": "Dashboard",
          "INSTRUCTION_2": "Mortgage Calculator",
          "INSTRUCTION_3": "Mortgage Calculator",
          "INSTRUCTION_4": "OverPayment",
          "INSTRUCTION_5": "Rate Change",
          "INSTRUCTION_6": "Select Account",
          "INSTRUCTION_7": "Select From Account",
          "INSTRUCTION_8": "Please Select",
          "INSTRUCTION_9": "Overpayment Details",
          "INSTRUCTION_10": "Original Principal",
          "INSTRUCTION_11": "Outstanding Balance Excluding Fees and Charges",
          "INSTRUCTION_12": "Interest rate",
          "INSTRUCTION_13": "Original Term",
          "INSTRUCTION_14": "Remaining Term",
          "INSTRUCTION_15": "Current Monthly Instalment (CMI)",
          "INSTRUCTION_16": "Completion Date",
          "INSTRUCTION_17": "Early Repayment Charge",
          "INSTRUCTION_18": "Repayment Value *",
          "INSTRUCTION_19": "Enter your repayment amount",
          "INSTRUCTION_20": "Continue",
          "INSTRUCTION_21": "Rate Change Details",
          "INSTRUCTION_22": "Rate Type",
          "INSTRUCTION_23": "Base/Step One Base Rate",
          "INSTRUCTION_24": "Margin",
          "INSTRUCTION_25": "Rate Change Date *",
          "INSTRUCTION_26": "New Rate *",
          "INSTRUCTION_27": "Results",
          "INSTRUCTION_28": "Output for the entered Repayment Amount",
          "INSTRUCTION_29": "Revised Monthly Instalment(Outstanding term remaining the same)",
          "INSTRUCTION_30": "Reduction of Current Monthly Instalment(CMI)",
          "INSTRUCTION_31": "Revised Remaining Term(Monthly instalment remaining the same)",
          "INSTRUCTION_32": "Reduction of Terms",
          "INSTRUCTION_33": "Arrears",
          "INSTRUCTION_34": "Early Repayment Charge",
          "INSTRUCTION_35": "28 days interest",
          "INSTRUCTION_36": "Repayment Value",
          "INSTRUCTION_37": "Adjust Value",
          "INSTRUCTION_38": "Change Calculator",
          "INSTRUCTION_39": "Please be advised that the above figure is based on your account details as of today and is for illustration purposes only. Should you wish to make a lumpsum payment to your account then please call us to discuss this further.",
          "INSTRUCTION_40": "Output for the entered ",
          "INSTRUCTION_41": "Fixed Rate Period",
          "INSTRUCTION_42": "Instalment for Fixed Period",
          "INSTRUCTION_43": "Variable Period",
          "INSTRUCTION_44": "Instalment for Variable Period",
          "INSTRUCTION_45": "Remaining Principal Balance",
          "INSTRUCTION_46": "Please be advised that the above interest rate and instalment value are for illustration processes only. You will receive a letter confirming your new payment value 30 days before your rate is due to change.",
          "INSTRUCTION_47": "Account Number",
          "INSTRUCTION_48": "Enter Rate Change Date",
          "INSTRUCTION_49": "Enter New Rate",
          "VIEW_BUTTON": "View"
        }
      },
      "WEB_STATEMENT": {
        "labels_en": {
          "HEADING_1": "Statements",
          "TAB_1": "Savings",
          "TAB_2": "Mortgages",
          "INSTRUCTION_1": "Account Number",
          "INSTRUCTION_2": "From Date",
          "INSTRUCTION_3": "To Date",
          "INSTRUCTION_4": "*Make sure you must allow popup in your browser to download the statements.",
          "INSTRUCTION_5": "of",
          "INSTRUCTION_6": "A Redemption Statement will be required if you plan on repaying your account off early. All of our Redemption Statements are valid for 28 days as stated in your terms and conditions. Any request for this statement will be processed within 48 working days.",
          "INSTRUCTION_7": "Your account statement contains all instalments due and all payments received, on the right hand side you will see a running account balance.",
          "INSTRUCTION_8": "The Arrears Statement will provide you with a breakdown for all missed payments and any additional fees and charges applied to your account if applicable.",
          "VIEW_BUTTON": "View",
          "DOWNLOAD_STATEMENT_BUTTON": "Download Statement",
          "BREADCRUMB_HOME": "Dashboard",
          "BREADCRUMB_1": "Statements",
          "ERROR_TEXT_1": "Please select to date",
          "ERROR_TEXT_2": "Please select from date",
          "ERROR_TEXT_3": "Please select valid date",
          "ERROR_TEXT_4": "Please select valid from date",
          "ERROR_TEXT_5": "From date and To date cannot be same.",
          "ALERT_1": "Sorry, some error occurred Please try again.",
          "ALERT_TITLE": "Alert",
          "ALERT_OK_BUTTON": "Ok",
          "WARNING_MESSAGE_1": "Account not selected, please select account again.",
          "Previous_Page": "Previous Page",
          "Next_Page": "Next Page",
          "Acc_search_Error_Msg": "Please enter valid account number or account holder name.",
          "SEARCH_PLACEHOLDER": "Search Savings Account",
          "STATEMENT_TYPE_LABEL": "Statement Type",
          "REDEMPTION_REQ_STATEMENT_MSG_LABLE": "Thank you for your request. A statement will be produced and uploaded to your documents within 48 working hours.",
          "REDEMPTION_STATEMENT_LABEL": "Redemption Statement",
          "ACCOUNT_STATEMENT_LABEL": "Account Statement",
          "ARREARS_STATEMENT_LABEL": "Arrears Statement",
          "TABLE_DATE_HEADER": "Date",
          "TABLE_DESCRIPTION_HEADER": "Description",
          "TABLE_AMOUNT_HEADER": "Amount",
          "TABLE_BALANCE_HEADER": "Balance",
          "PREVIOUS_BUTTON": "Previous",
          "NEXT_BUTTON": "Next",
          "PAGE_LABEL": "Page",
          "OF_LABEL": "of",
          "ACCOUNT_NUMBER_LABEL": "Account Number",
          "NOT_AVAILABLE_LABEL": "N/A",
          "CURRENT_BALANCE_LABEL": "Current Balance",
          "INTEREST_28DAYS_LABEL": "28 Days Interest",
          "INTEREST_DUE_LABEL": "Interest Due",
          "EARLY_REPAYMENT_LABEL": "Early Repayment Charge",
          "REDEMPTION_NOTE_LABEL": "Please note, this is an estimate. Contact us should you wish to redeem.",
          "REDEMPTION_STATEMENT_BUTTON": "Redemption Statement",
          "REQUEST_ARREARS_BUTTON": "Request Statement of Arrears",
          "MODAL_CHOOSE_OPTION_LABEL": "Choose an option to View your Amount or Download your Statement.",
          "REDEMPTION_FIGURE_BUTTON": "Redemption Figure",
          "REQUEST_REDEMPTION_BUTTON": "Request Redemption Statement",
          "REDEMPTION_REQUIREMENT_NOTE": "If you plan to repay your account in full within the next 28 days then a redemption statement will be required.",
          "AMOUNT_TO_REDEEM_LABEL": "Amount to Redeem",
          "PRINT_BUTTON": "Print Statement"
        }
      },
      "WEB_ACCOUNT_CONFIRMATION": {
        "labels_en": {
          "HEADING_1": "Step One Account Type Selection",
          "HEADING_2": "What type of account are you registering for?",
          "BUTTTON_1": "Business, Charity and Professional Accounts",
          "BUTTTON_2": "Personal Account",
          "BUTTTON_3": "Client or Pension Account"
        }
      },
      "WEB_SIDEBAR": {
        "labels_en": {
          "BUTTTON_1": "HOME"
        }
      }
    }
  }
  constructor(
    private events: Events,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private secureStorage: SecureStorageProvider,
    private gateway: GatewayClientProvider,
    private languageProvider: LanguageProvider,
    private platform: Platform,
    public device: Device) {
    window.is_labels_lodaed = this.local_labelsData ? true : false;
    // this.events.subscribe("consectus:setimeout.banksettings", this.getBankSettings.bind(this));
    // this.events.subscribe("consectus:setimeout.getlabels", this.getLabels.bind(this));
  }

  init(app, nav) {
    this.app = app;
    this.nav = nav;
    let self = this;
    return new Promise(function (resolve, reject) {
      if (false) {
        self.secureStorage.getStorage()
          .then((storage: SecureStorageObject) => {
            //see if sql storage has data;
            self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
            self.sql_db.transaction(function (transaction) {
              transaction.executeSql("SELECT COUNT(*) AS rowcount FROM tblconsectus WHERE title=?", ['consectusapp'], function (tx, result) {

                if (result.rows.item(0).rowcount == 0) {

                  self.sql_db.transaction(function (insert_transaction) {
                    insert_transaction.executeSql("INSERT INTO tblconsectus (title) VALUES (?)", ["consectusapp"], function (tx2, result2) {

                    },
                      function (insert_error) {

                      });
                  })
                  //new install
                  self.loadDevSettings().then(() => {
                    self.getAccountBanksetting().then((result: any) => {

                      self.settings.bank_sortcode = result.bank_sortcode;
                      self.settings.bank_accountno = result.bank_accountno;
                      self.settings.appVersion = result.version;
                      self.settings.forced = result.forced;
                      self.settings.islive = result.islive;


                      if (window.clientDemo) {
                        // debugger;
                        self.settings.customerId = window.clientCustomerId;
                        self.settings.status = "Existing Active";
                        self.setSettings(self.settings).then((data) => {
                        }).catch((err) => { })
                      }
                      resolve(result);
                    }).catch((banksetting_err) => {

                      reject(banksetting_err);
                    })
                  });
                }
                else {
                  storage.get("settings").then(
                    (data: any) => {

                      if (data) {


                        self.settings = JSON.parse(data);
                        self.getAccountBanksetting().then((result: any) => {

                          if (!self.settings.newAccountId && !window.clientDemo) {
                            self.loadDevSettings().then(() => {
                              resolve(result);
                            }).catch((error) => reject(error));
                          } else {
                            if (window.clientDemo) {
                              // debugger;
                              self.settings.customerId = window.clientCustomerId;
                              self.settings.status = "Active";
                              self.settings.newAccountId = 1;
                            }
                            resolve(result);
                          }
                          self.settings.bank_sortcode = result.bank_sortcode;
                          self.settings.bank_accountno = result.bank_accountno
                          self.settings.appVersion = result.version;
                          self.settings.forced = result.forced;
                          self.settings.islive = result.islive;
                          self.isForced = result.forced;

                          self.setSettings(self.settings).then((data) => {

                          }).catch((err) => { })
                        }).catch((banksetting_err) => {

                          reject(banksetting_err);
                        })
                      }
                      else {

                        // window.showNotSecure();
                        window.hideAllError();
                        window.hideSplash();
                      }
                    })
                    .catch((error) => {


                      self.loadDevSettings().then(() => {
                        resolve(true);
                      });
                    });
                }
              },
                function (error) {
                  // window.showNotSecure();
                  window.hideAllError();
                  window.hideSplash();
                  reject(self.languageProvider.get("Sorry, to ensure security, the device must be Screen Locked with PIN/Password/Pattern"));
                });
            })
          })
          .catch((error) => {


            // window.showNotSecure();
            window.hideAllError();
            window.hideSplash();
            reject(self.languageProvider.get("Sorry, to ensure security, the device must be Screen Locked with PIN/Password/Pattern"));
          });
      } else {
        self.loadDevSettings().then(() => {
          resolve(true);
        }).catch((error) => {


          reject(error);
        })
      }
    });
  }

  loadDevSettings() {
    this.settings = {
      bank_sortcode: "",
      bank_accountno: "",
      customerId: "",
      customer_Id: "",
      consectusId: "",
      account_number: "",
      fullname: "",
      firstname: "",
      lastname: "",
      pin: "",
      passcodeBlocked: "",
      memberid: "",
      customersid: "",
      token: "",
      devicetype: "",
      nominatedbankno: "",
      nominatedbanksortcode: "",
      accountholdername: "",
      customername: "",
      addressEditable: true,
      emailid_bank: "",
      mobileno_bank: "",
      newExistingMobileNumber: "",
      external_amount: "",
      external_notifications: false,
      external_number: "",
      productInformation: false,
      messageBadgeCount: 0,
      totalcount: 0,
      productBadgeCount: 0,
      newsBadgeCount: 0,
      status: "New Install",
      touchEnabled: true,
      attempts: 0,
      maxAttempts: 3,
      newAccountId: "",
      newUser: true,
      isSetupSweeper: false,
      userMobileNo: "",
      userEmail: "",
      userNumber: "",
      lastlogin: "",
      product_list: [],
      selectedProduct: "",
      correspondenceaddress: {},
      is_parents: false,
      accountcode: "",
      noticeperiod: {},
      ratechangeperiod: {},
      product_application_id: "",
      new_account_types_id: "",
      products_id: "",
      productsid: "",
      product_name: "",
      forced: 0,
      islive: 0,
      account_types_id: 0,
      existingCustomer: false,
      isMobileVerified: true,
      notification: null,
      notification_id: 0,
      productnotifications: [],
      messagenotifications: [],
      postnotification: false,
      smsnotification: false,
      telephonenotification: false,
      mailnotitfication: false,
      maxTouchIdAttempt: 0,
      isSendMailerMail: false,
      isSendPasscodeMail: false,
      isSendRegisterMail: false,
      isSendMemberIdMail: false,
      isSendExisitingMail: false,
      isSendLoginMail: false,
      isForgotPin: false,
      startTimer: null,
      customer_devices_id: 0,
      timeOut: 0,
      product_application_arr: [],
      pending_documents: 0,
      pending_documents_msg: "",
      isSetPin: true,
      isLoginBlocked: false,
      isApplicationBlocked: false,
      timeOutCount: 0,
      productFormData: {},
      productFormData2: {},
      isExistingNumber: false,
      isNewExistingNumber: false,
      isActiveNumber: false,
      bankcustomers_id: "",
      bankSettingData: null,
      labelsData: null,
      appVersion: window.clientDemo ? window.AppVersion : "",
      isaccountprocessed: false,
      maxDate: [],
      minDate: [],
      moveInMax: [],
      accounts_rules_engine: [],
      sopra_ftr_verified: 0,
      rules_engine: {},
      selectedidentity: null,
      selectedaddress: null,
      passport: false,
      drivinglicense: false,
      document_attempts: 3,
      onmailer_attempts: 3,
      document_status: false,
      marketing_post: false,
      marketing_email: false,
      marketing_telephone: false,
      marketing_mobilephonesms: false,
      fiveyears: 0,
      smartsaver: {
        connections: [],
        savingrules: []
      },
      gendertitle: [],
      country: [],
      nationality: "",
      nationality_code: "",
      birthcountry: "",
      birthcountry_code: "",
      isnbaverify: null,
      jumioerrors: "",
      isdetailsverify: null,
      isnbaverified: null,
      isniverified: null,
      isAddressVerified: null,
      rateAsk: true,
      current_date: "",
      neverAsk: false,
      manually_logout: false,
      timer_logout: false,
      onboarding_time: "",
      remind_later: 0,
      ismaturity: 0,
      maturityselected: null,
      ispep: false,
      ispeprelative: false,
      issanction: false,
      accountType: "",
      uuid: null,
      isncr: false,
      product_type: [],
      new_accounts_id: "",
      regular: {
        product: null,
        amount: null,
        frequency: null,
        first_payment_date: null,
        new_accounts_id: null
      },
      online_userid: "",
      form: "",
      jointAccount: "",
      is_junior: 0,
      passport_ssid: "",
      driving_ssid: "",
      linkedAccountIdentifier: "",
      flow: "",
      origin: {},
      childaccount: false,
      isproduct_redirect: false,
      transaction: 1,
      updatenba: 1,
      product: 1
    };
    let self = this;
    return new Promise((resolve, reject) => {
      try {
        if (window.clientDemo) {
          // debugger;
          self.settings.customerId = window.clientCustomerId;
          self.loadGatewayData().then(() => {
            self.events.publish("consectus:settings.ready");
            resolve("Loaded settings")
          }).catch((error) => {

            reject(error);
          })
        } else {
          //generate new accounts id
          // console.log(self.platform.is("cordova"), "349 self.platform.is(cordova)")
          // kaviraj vikrant remove the hardcoded skipping of registernewcustomer
          if (false) {
            self.gateway.registerNewCustomer({}).then((data: any) => {
              self.settings.status = data.state_status;
              self.settings.newAccountId = data.new_accounts_id;
              self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
              self.sql_db.transaction(function (transaction) {
                transaction.executeSql('CREATE TABLE IF NOT EXISTS tbl_new_accounts (uuid text)', [],
                  function (tx1, result) {
                    self.sql_db.transaction(function (insert_transaction) {
                      insert_transaction.executeSql("INSERT INTO tbl_new_accounts (uuid) VALUES (?)", [data.uuid], function (tx2, result2) {
                      },
                        function (insert_error_2) {
                        });
                    });
                  },
                  function (create_error) {
                  });
              });
              self.setSettings(self.settings);
              resolve("New account registered");
            }).catch((error) => {
              reject(error);
            })
          }
          else {
            self.settings.status = "New Install Customer Validation";
            self.settings.newAccountId = 0;
            self.settings.uuid = "161-05caa291-890c-4db2-a24e-c20196825e2d";
            self.setSettings(self.settings);
            resolve("New account registered");
          }
        }
      } catch (error) {
        reject(error);
      }
    });
  }


  /**
   * Load gateway data
   * @param  
   */
  loadGatewayData() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.loadData()
        .then(() => {
          resolve(true);
        }).catch((error) => {

          reject(self.languageProvider.get("error loading demo data"));
        });
    })
  }

  async clearSettings(app, nav) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.secureStorage.getStorage()
        .then((storage: SecureStorageObject) => {
          storage.remove('settings')
            .then(async () => {
              if (self.platform.is("cordova")) {
                self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
                self.sql_db.transaction(async function (delect_transaction) {
                  delect_transaction.executeSql("DELETE FROM tblconsectus", [], async function (tx, result) {
                    delect_transaction.executeSql("DELETE FROM tbl_new_accounts", [], async function (tx, result) {
                      let initSettings = await self.init(app, nav);
                      if (initSettings) {
                        self.updateStatus("New Install Customer Validation").then((data) => {
                        });
                        self.getAllStatus();
                      }
                      let s = self.settings;
                      s.maxTouchIdAttempt = 0;
                      s.timeOut = 0; // This is only for save attempt = 0
                      self.setSettings(s).then((data: any) => {
                      });
                    },
                      function (error) {
                        // window.showNotSecure();
                        window.hideAllError();
                        window.hideSplash();
                        reject(self.languageProvider.get("Sorry, to ensure security, the device must be Screen Locked with PIN/Password/Pattern"));
                      });
                  },
                    function (error) {
                      // window.showNotSecure();
                      window.hideAllError();
                      window.hideSplash();
                      reject(self.languageProvider.get("Sorry, to ensure security, the device must be Screen Locked with PIN/Password/Pattern"));
                    });
                });
              }
              self.settings = null;
              resolve(true);
            })
            .catch((error) => {
              //self.settings = null;
              reject(self.languageProvider.get("Error ocurred during storage!!!"));
            });
        }).catch((error) => {
          resolve(false)
        });
    });
  }

  /**
   * Remove this function after onboarding
   * @param data 
   */
  setSettings(data) {
    let self = this;
    if (data.status == undefined) {
      if (data.customerId != undefined) {
        data.status = "Active";
      }
    }
    return new Promise(function (resolve, reject) {
      if (self.platform.is("cordova")) {
        if (data.consectusId) {
          if (data.customerId) { }
          else {
            let auditUser = {
              "users_id": 0,
              "customer_devices_id": 0,
              "usertype": "Customer",
              "uuid": "",
              "appname": "MobileApp",
              "event_type": "view",
              "screen": "Accounts",
              "trail_details": JSON.stringify(data),
              "devicetype": self.device.platform
            }
            self.gateway.loadaudit(auditUser);
          }
        }
        self.secureStorage.getStorage()
          .then((storage: SecureStorageObject) => {
            storage.set("settings", JSON.stringify(self.settings)).then(() => {

              self.settings = data;
              resolve(true);
            })
              .catch((error) => {

                reject(error);
              })
          });
      } else {
        self.settings = data;
        resolve(true);
      }
    });
  }

  /**
   * Show Loading for the app
   */
  showLoading() {
    if (!this.loading) {
      this.loading = this.loadingCtrl.create();
      this.loading.present();
    }
  }

  /**
   * Page loafding after push the page from menu
   */

  pageLoading(msg) {
    // if (!this.loading) {
    this.loading = this.loadingCtrl.create({
      content: msg,
      dismissOnPageChange: true,
      showBackdrop: false
    });
    this.loading.present();
    // }
  }

  /**
   * Hide Loaidng after push the page from menu
   */

  hideLoading() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  /**
   *  Comman messages displaying from here
   */

  showWarning(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      message: this.languageProvider.get(msg),
      buttons: [
        {
          text: this.languageProvider.get("OK"),
          role: 'ok',
          handler: () => {
          }
        }
      ]
    });
    alert.present();
  }
  /**
   * Set App marketing prefrences
   * @param marketProductInformation 
   */
  setAppMarketingpreferences(marketProductInformation) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setAppMarketingpreferences(marketProductInformation)
        .then((result) => {
          resolve(result)
        });
    });
  }

  /**
   * Set App Third Party Notifications
   * @param thirdpartynotifications 
   */
  setThirdPartyNotifications(thirdpartynotifications) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setThirdPartyNotifications(thirdpartynotifications)
        .then((result) => {
          resolve(result)
        });
    });
  }

  /**
   * Set Third party number
   * @param setthirdpartynumber 
   */
  setThirdpartyNumber(setthirdpartynumber) {

    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setThirdpartyNumber(setthirdpartynumber)
        .then((result) => {
          resolve(result)
        });
    });
  }

  /**
   * Get All app setting 
   */
  getAppSettings() {
    let self = this;
    return new Promise(function (resolve, reject) {
      let custormer_id = {
        customers_id: self.settings.customerId
      }
      self.gateway.getAppSettings(custormer_id)
        .then((result: any) => {
          self.settings.userNumber = result.data[0].mobileno_user;
          //self.settings.userEmail = result.data[0].emailid_user;
          self.settings.userEmail = result.data[0].emailid_bank ? result.data[0].emailid_bank : result.data[0].emailid_user;
          self.settings.productInformation = result.data[0].marketingpreferences;
          self.settings.touchEnabled = result.data[0].istouchid;
          self.settings.external_notifications = result.data[0].thirdpartynotifications;
          self.settings.external_number = result.data[0].emerygencymobileno;
          self.settings.external_amount = result.data[0].maxamount;

          self.setSettings(self.settings).then(() => {

          })
          resolve(true)
        });
    });
  }

  /**
   * Get All app setting 
   */
  getDataForSettingsPage() {
    let self = this;
    return new Promise(function (resolve, reject) {
      let custormer_id = {
        customers_id: self.settings.customerId
        // customers_id: 772, //shivkumar
      }
      self.gateway.getAppSettings(custormer_id)
        .then((result: any) => {
          self.settings.userNumber = result.data[0].mobileno_user;
          //self.settings.userEmail = result.data[0].emailid_user;
          self.settings.userEmail = result.data[0].emailid_bank ? result.data[0].emailid_bank : result.data[0].emailid_user;
          self.settings.productInformation = result.data[0].marketingpreferences;
          self.settings.touchEnabled = result.data[0].istouchid;
          self.settings.external_notifications = result.data[0].thirdpartynotifications;
          self.settings.external_number = result.data[0].emerygencymobileno;
          self.settings.external_amount = result.data[0].maxamount;

          self.setSettings(self.settings).then(() => {

          })
          resolve(result)
        });
    });
  }


  /**
   * Update Touch id status
   * @param touchId 
   */
  updateTouch(touchId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateTouchId(touchId)
        .then((data) => {
          resolve(data);
        })
    })
  }

  loadaudit(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.loadaudit(body)
        .then((data) => {
          resolve(data);
        })
    })
  }

  /**
   * Get all the page labels
   * @param pagename :Use for the page labels
   */
  getAppLabels(pagename) {
    let self = this;
    if (self.labelsData !== undefined && self.labelsData !== null) {
      for (let key1 in self.labelsData.web[pagename]) {
        if (key1 == "labels_" + self.languageString) {
          self.resultData = self.labelsData.web[pagename][key1];
        } else if (key1 == "labels_en") {
          self.resultData = self.labelsData.web[pagename][key1];
        }
      }
    }
    else {
      for (let key1 in self.local_labelsData.web[pagename]) {
        if (key1 == "labels_" + self.languageString) {
          self.resultData = self.local_labelsData.web[pagename][key1];
        } else if (key1 == "labels_en") {
          self.resultData = self.local_labelsData.web[pagename][key1];
        }
      }
    }
    // console.log("self.resultData 1 ==>", self.resultData);
  }
  /** <----------Get All Online Labels----------> **/

  /**
  
   *
  
   * @returns
  
   */

  getOnlineLabels() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getlabels()
        .then((data: any) => {
          self.labelsData = data.onlinelabel;
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }
  /**
   * Get page key from page Labels
   * @param key : find key in page labels
   */
  getLabel(key, html_pagename = null) {
    let self = this;
    if (self.resultData !== null && self.resultData[key] !== undefined) {
      return self.resultData[key];
    } else {
      if (html_pagename && self.local_labelsData && self.local_labelsData.web) {
        for (let key1 in self.local_labelsData.web[html_pagename]) {
          if (key1 == "labels_" + self.languageString) {
            self.resultData = self.local_labelsData.web[html_pagename][key1];
            return self.resultData[key];
          } else if (key1 == "labels_en") {
            self.resultData = self.local_labelsData.web[html_pagename][key1];
            return self.resultData[key];
          }
        }
      }
      return key;
    }
  }

  /**
   * Remove special character validation
   * @param validateData 
   */
  specialCharcterValidation(validateData) {
    if (validateData.replace(/[^A-Za-z0-9]/g, "") == "") {
      return false;
    } else {
      return true
    }
  }

  /**
   * Common api for the loadaudit
   * @param userType 
   * @param eventType 
   * @param screenName 
   * @param trailDetails 
   */
  loadAudit(userType, eventType, screenName, trailDetails, devicetype) {
    let self = this;
    let body = {
      "users_id": userType == "newaccount" ? self.settings.newAccountId : userType == "ECAO" ? self.settings.productFormData.product_application_id : self.settings.customerId,
      "customer_devices_id": self.settings.customer_devices_id == "" || self.settings.customer_devices_id == null ? 0 : self.settings.customer_devices_id,
      "usertype": userType,
      "uuid": self.device.uuid,
      "appname": self.AppName,
      "event_type": eventType,
      "screen": screenName,
      "trail_details": trailDetails,
      "devicetype": devicetype,
    }
    return new Promise(function (resolve, reject) {
      self.gateway.loadaudit(body)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err)
        });
    })
  }

  loadAuditPyacaso(userType, eventType, screenName, trailDetails, data_response, data_error) {
    let self = this;
    let body = {
      "new_accounts_id": self.settings.newAccountId,
      "users_id": userType == "newaccount" ? self.settings.newAccountId : self.settings.customerId,
      "customer_devices_id": self.settings.customer_devices_id == "" || self.settings.customer_devices_id == null ? 0 : self.settings.customer_devices_id,
      "usertype": userType,
      "uuid": self.device.uuid,
      "appname": self.AppName,
      "event_type": eventType,
      "screen": screenName,
      "trail_details": trailDetails,
      "devicetype": self.device.platform,
      "data_response": data_response,
      "data_error": data_error,
    }
    return new Promise(function (resolve, reject) {
      self.gateway.loadaudit(body)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err)
        });
    })
  }

  /**
   * Common alertcontroller
   */
  commonAlertCtrl(title, message, buttonText) {
    let self = this;
    let alert = self.alertCtrl.create({
      title: self.getLabel(title),
      message: self.getLabel(message),
      buttons: [
        {
          text: self.getLabel(buttonText),
          role: 'Ok',
          handler: () => {

          }
        },
      ]
    });
    alert.present();
  }
  InputEmailAlertBox(callback: Function = null): void {
    let self = this;
    let alert = self.alertCtrl.create({
      title: "Email Address",
      message: "Please enter your email address to continue",
      inputs: [
        {
          name: 'email',
          placeholder: 'Enter your email',
          type: 'email'
        }
      ],
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: function (data) {
            if (data.email === "") {
              self.commonAlertCtrl("Empty Email", "Please enter your email address to continue", "OK");
            } else if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(data.email)) {
              self.commonAlertCtrl("Invalid Email", "Please enter a valid email address", "OK");
            } else {
              let s = self.settings;
              s.userEmail = data.email;
              self.setSettings(s);
              if (callback !== null) callback();
            }
          }
        },
        {
          text: "Cancel",
          role: 'cancel',
          handler: () => {
          }
        }
      ], cssClass: 'alertsmallfont',

    });
    alert.present();
  }

  /**
   * Save application status to server
   * @param status Application status in string
   * 
   */
  saveApplication(status: string): void {
    try {
      let self = this;
      let s = self.settings;
      if (!(s.productFormData && s.productFormData.emailid)) {
        if (!s.userEmail) {
          const call_back = self.saveApplication.bind(this, status);
          self.InputEmailAlertBox(call_back);
          return;
        }
      }
      const data = {
        new_accounts_id: s.new_accounts_id,
        status: status,
        email: (s.productFormData && s.productFormData.emailid) ? s.productFormData.emailid : s.userEmail,
        settingsformdata: self.settings
      };
      self.gateway.SaveApplicationStatusOnline(data)
        .then((res: any) => {
          if (res.status) {
            self.commonAlertCtrl("Success", "Application saved successfully", "OK");
          } else {
            // console.debug(res);
          }
        }).catch((error) => {/**console.error(error)*/ });
    } catch (error: any) {
      // console.error(error)
    }
  }

  /**
   * Get customer statusby customer ID
   */
  getAccountBanksetting() {
    let self = this;
    let devicetype = {
      devicetype: "web"
    }
    return new Promise(function (resolve, reject) {
      self.gateway.getAccountBanksetting(devicetype).then((result: any) => {
        self.appVersion = result.version;
        self.isForced = result.banksettings.isforced;
        self.islive = result.banksettings.islive;
        let banksettings = result.banksettings;
        // self.labelsData = result.labels;

        //self.settings.gendertitle = result.gendertitle;
        //self.settings.country = result.country;

        // 
        //

        self.bankSettingData = {
          "feature_nonpersonalregistration": banksettings.feature_nonpersonalregistration,
          "feature_personal": banksettings.feature_personal,
          "feature_client_peronsal": banksettings.feature_client_peronsal,
          "feature_business_charity_trust": banksettings.feature_business_charity_trust,
          "transfer_max_day": banksettings.transfer_max_day,
          "bank_sortcode": banksettings.sortcode,
          "bank_accountno": banksettings.account_number,
          "version": result.version,
          "customer_status": result.customer_status,
          "stauts": result.customer_status,
          "banksettings_id": banksettings.banksettings_id ? true : false,
          "menu_branches": banksettings.menu_branches ? true : false,
          "menu_calculators": banksettings.menu_calculators ? true : false,
          "menu_cheque": banksettings.menu_cheque ? true : false,
          "menu_contactus": banksettings.menu_contactus ? true : false,
          "menu_download": banksettings.menu_download ? true : false,
          "menu_makepayment": banksettings.menu_makepayment ? true : false,
          "menu_statements": banksettings.menu_statements ? true : false,
          "menu_updateprofile": banksettings.menu_updateprofile ? true : false,
          "menu_existing_account": banksettings.menu_existing_account ? true : false,
          "menu_goals": banksettings.menu_goals ? true : false,
          "menu_members": banksettings.menu_members ? true : false,
          "menu_messages": banksettings.menu_messages ? true : false,
          "menu_new_account": banksettings.menu_new_account ? true : false,
          "menu_paycontacts": banksettings.menu_paycontacts ? true : false,
          "menu_prodcuts": banksettings.menu_prodcuts ? true : false,
          "menu_regularsavings": banksettings.menu_regularsavings ? true : false,
          "menu_saver": banksettings.menu_saver ? true : false,
          "menu_saver_regular": banksettings.menu_saver_regular ? true : false,
          "menu_saver_smart": banksettings.menu_saver_smart ? true : false,
          "menu_saver_sweeper": banksettings.menu_saver_sweeper ? true : false,
          "menu_savinganalysis": banksettings.menu_savinganalysis ? true : false,
          "menu_settings": banksettings.menu_settings ? true : false,
          "menu_termsconditions": banksettings.menu_termsconditions ? true : false,
          "menu_thirdparty": banksettings.menu_thirdparty ? true : false,
          "mortgageaccount": banksettings.mortgageaccount ? true : false,
          "savingsaccount": banksettings.savingsaccount ? true : false,
          "currentaccount": banksettings.currentaccount ? true : false,
          "externalaccount": banksettings.externalaccount ? true : false,
          "firstname": banksettings.customer_firstname !== undefined ? banksettings.customer_firstname : null,
          "lastname": banksettings.customer_lastname !== undefined ? banksettings.customer_lastname : null,
          "lastlogin": banksettings.customer_lastlogin !== undefined ? banksettings.customer_lastlogin : null,
          "defaultAccountType": "",
          "forced": result.banksettings.forced,
          "islive": result.banksettings.islive
        }
        if (self.bankSettingData.currentaccount) {
          self.bankSettingData.defaultAccountType = "current";
        } else if (self.bankSettingData.savingsaccount) {
          self.bankSettingData.defaultAccountType = "savings";
        } else if (self.bankSettingData.mortgageaccount) {
          self.bankSettingData.defaultAccountType = "mortgages";
        } else if (self.bankSettingData.externalaccount) {
          self.bankSettingData.defaultAccountType = "external";
        }
        if (window.clientDemo) {
          self.bankSettingData.firstname = "Mr j";
          self.bankSettingData.lastname = "smith";
          self.bankSettingData.lastlogin = new Date();
        }
        self.bankSettingsLoaded = true;
        self.events.publish("consectus:banksettings:updated");
        resolve(self.bankSettingData)
      }).catch((error) => {

      })
    });

  }

  /**
   * Wait until /accounts/getbanksettings has populated bankSettingData.
   * Resolves true once loaded, false if the call never came back (API failure)
   * so callers can fail closed instead of reading an empty bankSettingData.
   */
  waitForBankSettings(timeoutMs: number = 15000): Promise<boolean> {
    let self = this;
    if (self.bankSettingsLoaded) {
      return Promise.resolve(true);
    }
    return new Promise<boolean>((resolve) => {
      let settled = false;
      let handler = () => finish(true);
      let timer = setTimeout(() => finish(self.bankSettingsLoaded), timeoutMs);
      function finish(loaded) {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(timer);
        self.events.unsubscribe("consectus:banksettings:updated", handler);
        resolve(loaded);
      }
      self.events.subscribe("consectus:banksettings:updated", handler);
    });
  }

  /**
   * True when the bank has switched the given menu_* column on.
   */
  isFeatureEnabled(menuFlag: string): Promise<boolean> {
    let self = this;
    return self.waitForBankSettings().then(() => !!self.bankSettingData[menuFlag]);
  }

  /**
   * ionViewCanEnter helper for online pages gated by a banksettings menu_* column.
   * Hiding the side menu button is not enough on web: the page still has a
   * deep-link segment, so a customer can type the URL. Returning false here
   * blocks the transition; the redirect is deferred because a rejected
   * transition wipes the nav queue.
   * @param menuFlag  bankSettingData column, e.g. "menu_statements"
   * @param navCtrl   the page's own NavController
   * @param fallbackPage page to bounce to when the feature is off
   */
  canEnterFeature(menuFlag: string, navCtrl: any, fallbackPage: string = "WebAccountsPage"): Promise<boolean> {
    let self = this;
    return self.isFeatureEnabled(menuFlag).then((enabled) => {
      if (!enabled) {
        self.hideLoading();
        self.showWarning("Sorry", "This feature is not allowed for your account.");
        setTimeout(() => {
          try {
            navCtrl.setRoot(fallbackPage);
          } catch (error) {
            // nav already gone, nothing to bounce to
          }
        }, 0);
      }
      return enabled;
    });
  }


  // Get Customer Status
  getCustomerStatus(customerId) {
    let self = this;
    let customerdata = {
      "customers_id": customerId
    }
    return new Promise((resolve, reject) => {
      self.gateway.getCustomerStatus(customerdata).then((result) => {
        resolve(result)
      }).catch((err) => {
        reject(err);
      })
    })
  }

  /**
    * 
    * @param status 
    * @param checkStatus 
    */
  updateStatus(status) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let customerData = {
        new_accounts_id: self.settings.newAccountId,
        state_status: status
      };
      self.gateway.changeCustomerStatus(customerData).then((result: any) => {
        self.settings.status = result.state_status;
        self.getAllStatus();
        resolve(true);
      }).catch((err) => {
        reject(err)
      });
    });
  }

  /**
   * Restrict character from number input
   * @param event 
   */
  onKeyUp(event: any) {
    let newValue = event.target.value;
    let regExp = new RegExp('^[0-9]+$');
    if (!regExp.test(newValue)) {
      event.target.value = newValue.slice(0, -1);
    }
  }

  /**
   * check the user status on onboarding  process and redirect that page where he was
   * stopped last time in onboarding process
   */
  getAllStatus() {
    let self = this;
    // console.log("setting1", self.settings.status);

    switch (self.settings.status.toUpperCase()) {
      case "New Install".toUpperCase():
      case "New Install Customer Validation".toUpperCase():
        if (window.location.href.split("#")[1] !== "/hint") {
          self.nav.setRoot("HintPage")
        }
        break;
      case "New Passcode Validated".toUpperCase():
        self.nav.setRoot("SelectProductPage");
        break;
      case "New Existing Customer".toUpperCase():
        self.nav.setRoot("NewMemberExistingVerificationPage");
        break;
      case "New Existing Customer ID".toUpperCase():
        self.settings.memberid = "";
        self.nav.setRoot("ValidateMembershipPage");
        break;
      case "Existing Setpin".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "New Existing Setpin".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "Existing User Verification".toUpperCase():
        self.nav.setRoot("ExistingNumberConfirmationPage");
        break;
      case "Existing Customer Validation".toUpperCase():
        self.nav.setRoot("ExistingConfirmationPage");
        break;
      case "Existing Customer Verification".toUpperCase():
        self.nav.setRoot("HintPage");
        break;
      case "New Install Passcode Blocked".toUpperCase():
      case "Active Passcode Blocked".toUpperCase():
      case "New Existing Passcode Blocked".toUpperCase():
      case "Existing Passcode Blocked".toUpperCase():
      case "New Install Enter Passcode Blocked".toUpperCase():
        self.nav.setRoot("OtpBlockedPage");
        break;
      case "New Customer Products Terms and Condition".toUpperCase():
        self.nav.setRoot("ProductTermsConditionsPage");
        break;
      case "New Customer Tax Residency".toUpperCase():
        self.nav.setRoot("TaxResidencyPage");
        break;
      case "Thank You New Customer".toUpperCase():
        self.nav.setRoot("ThankNewCustomerPage");
        break;
      case "Thank You New Existing Customer".toUpperCase():
      case "Thank You Existing Customer".toUpperCase():
      case "Thank You Active Customer".toUpperCase():
        self.nav.setRoot("ThankExistingCustomerPage");
        break;
      case "UK Residency Confirmation".toUpperCase():
        self.nav.setRoot("TaxConfirmationPage");
        break;
      case "New Account Type".toUpperCase():
        self.nav.setRoot("PagesJointAccountPage");
        break;
      case "New Customer Nominated Bank Details".toUpperCase():
        self.nav.setRoot("BankDetailsPage");
        break;
      case "Existing TermsandConditions".toUpperCase():
        self.nav.setRoot("AgreeTermsConditionsPage");
        // self.nav.setRoot("PagesDummyPage");
        break;
      case "Existing Found Active".toUpperCase():
      case "New Existing Found Active".toUpperCase():
      case "New Existing Found Existing".toUpperCase():
      case "Active Passcode Validated".toUpperCase():
      case "New Active Passcode Validated".toUpperCase():
      case "New Customer Found Active".toUpperCase():
      case "New Customer Found Existing".toUpperCase():
        self.nav.setRoot("ExistingCustomerVerificationPage");
        break;
      case "Restart Existing Registration".toUpperCase():
        self.settings.memberid = "";
        self.nav.setRoot("MobileVerificationPage");
        break;
      case "Active Resend Passcode".toUpperCase():
      case "Existing Resend Passcode".toUpperCase():
      case "New Existing Resend Passcode".toUpperCase():
      case "New Install Enter Mobile Number".toUpperCase():
      case "New Existing Enter Mobile Number".toUpperCase():
      case "Existing Enter Mobile Number".toUpperCase():
      case "Active Enter Mobile Number".toUpperCase():
        self.nav.setRoot("MobileVerificationPage")
        break;
      case "Active Enter Passcode".toUpperCase():
      case "Existing Enter Passcode".toUpperCase():
      case "New Existing Enter Passcode".toUpperCase():
      case "New Install Enter Passcode".toUpperCase():
      case "New Install Enter Resend Passcode".toUpperCase():
        self.nav.setRoot("OtpPage")
        break;
      case "New Existing Select Open New Account".toUpperCase():
        self.nav.setRoot("SelectProductPage");
        break;
      case "New Existing Found Existing Registration".toUpperCase():
      case "Existing Registration".toUpperCase():
      case "New Existing Registration".toUpperCase():
      case "New Customer Found Existing Registration".toUpperCase():
      case "Existing Forgot Pin Failed Verfication".toUpperCase():
        self.nav.setRoot("RegisterPage");
        break;
      case "New Existing Registration Blocked".toUpperCase():
      case "New Existing Found Existing Registration Blocked".toUpperCase():
      case "New Customer Found Existing Registration Blocked".toUpperCase():
      case "New Customer Found Existing Verification Blocked".toUpperCase():
        self.nav.setRoot("RegistrationBlockedPage");
        break;
      case "Existing Registration Blocked".toUpperCase():
        self.nav.setRoot("RegHoldingPage");
        break;
      case "New Existing TermsandConditions".toUpperCase():
        self.nav.setRoot("AgreeTermsConditionsPage");
        // self.nav.setRoot("PagesDummyPage");
        break;
      case "New TermsandConditions".toUpperCase():
        self.nav.setRoot("AgreeTermsConditionsPage");
        // self.nav.setRoot("PagesDummyPage");
        break;
      case "New Customer Select Product".toUpperCase():
        self.nav.setRoot("SelectProductPage");
        break;
      case "New Customer Contact Details".toUpperCase():
        self.nav.setRoot("ApplicationContactPage");
        break;
      case "New Customer Address Details".toUpperCase():
      case "New Customer Address Not Match With The Uploaded Documents".toUpperCase():
        self.nav.setRoot("ApplicationAddressPage");
        break;
      case "New Customer Account Holder Registeration 1".toUpperCase():
        self.nav.setRoot("TaxResidencyPage");
        break;
      case "New Customer Tax Residence".toUpperCase():
        self.nav.setRoot("TaxResidencyPage");
        break;
      case "New Customer select product".toUpperCase():
        self.nav.setRoot("SelectProductPage");
        break;
      case "New Customer Personal Details".toUpperCase():
      case "New Customer Name Is Not Match With The Uploaded Documents".toUpperCase():
      case "New Customer Date Of Birth Is Not Match With The Uploaded Documents".toUpperCase():
      case "New Customer Personal Details Not Matched".toUpperCase():
        self.nav.setRoot("ProductFormPage");
        break;
      case "New Customer 2nd Bank Holder Personal Details".toUpperCase():
        self.nav.setRoot("ProductFormPage");
        break;
      case "Existing Customer Document Verification".toUpperCase():
      case "New Customer Document Verification".toUpperCase():
      case "New Customer Identity Verification".toUpperCase():
      case "Existing Customer Identity Verification".toUpperCase():
      case "New Customer Address Verification".toUpperCase():
      case "New Customer Documents Reupload".toUpperCase():
      case "Existing Customer Documents Reupload".toUpperCase():
        self.nav.setRoot("UploadPassportPage");
        break;
      case "New Customer Account Processing".toUpperCase():
        self.nav.setRoot("ProcessingPage");
        break;
      case "New Customer Documents Not Matched".toUpperCase():
        self.nav.setRoot("NotMatchedPage", { sortcode: false });
        break;
      case "Existing Customer Documents Not Matched".toUpperCase():
        self.nav.setRoot("ExistingNotMatchedPage");
        break;
      case "New Customer Sort Code Not Matched".toUpperCase():
        self.nav.setRoot("NotMatchedPage", { sortcode: true });
        break;
      case "Existing Customer Address Verification".toUpperCase():
        self.nav.setRoot("UploadPassportPage");
        break;
      case "New Customer Document Verification Approved".toUpperCase():
      case "Existing Customer Document Verification Approved".toUpperCase():
        let ss = self.settings;
        ss.document_status = true;
        ss.passport = true;
        ss.drivinglicense = true;
        self.setSettings(ss);
        self.nav.setRoot("DocumentVerificationResultPage", { isSuccess: true });
        break;
      case "New Customer Verification Status".toUpperCase():
      case "Existing Customer verification Status".toUpperCase():
        self.nav.setRoot("DocumentVerificationResultPage");
        break;
      case "New Customer Verification Documents Confirmation".toUpperCase():
      case "Existing Customer Verification Documents Confirmation".toUpperCase():
        self.nav.setRoot("UploadPassportPage");
        break;
      case "New Customer Verification Documents Confirmation Check".toUpperCase():
        self.nav.setRoot("AccountsDocumentsCheckPage");
        break;
      case "New Customer Documents Verification Pending From Branch".toUpperCase():
      case "Existing Customer Documents Verification Pending From Branch".toUpperCase():
        self.nav.setRoot("DocumetsBlockPage");
        break;
      case "New Customer Documents Verification Continue From Branch".toUpperCase():
        self.nav.setRoot("AccountsDocumentsNotPage");
        break;
      case "Existing Customer Mailer".toUpperCase():
        self.nav.setRoot("ExistingScreenMessagePage");
        break;
      case "New Customer Bank Details".toUpperCase():
        self.nav.setRoot("BankDetailsPage");
        break;
      case "Existing Customer Child details".toUpperCase():
      case "New Customer Child details".toUpperCase():
        self.nav.setRoot("ProductQuestionsPage");
        break;
      case "New Customer Thank You For Application".toUpperCase():
        self.nav.setRoot("ThankYouApplyPage");
        break;
      case "New Customer Application Verification pending".toUpperCase():
        self.nav.setRoot("ThankYouApplyPage");
        break;
      case "New Customer Verification Pending".toUpperCase():
        self.nav.setRoot("ThankYouApplyPage");
        break;
      case "New Customer Rpa Agent Failed".toUpperCase():
        self.nav.setRoot("AccountCreditcheckFailedPage");
        break;
      case "New Customer Selected Product Approved".toUpperCase():
        self.nav.setRoot("UploadPhotoPage");
        break;
      case "New Customer Set PIN".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "Existing TermsandConditions".toUpperCase():
        self.nav.setRoot("AgreeTermsConditionsPage");
        break;
      case "Existing Registration Sopra Verification".toUpperCase():
      case "Existing Registration Passbook Restart".toUpperCase():
        self.nav.setRoot("RegisterPage");
        break;
      case "Existing Registration Sopra Failed".toUpperCase():
      case "Existing Registration Sopra Notverified".toUpperCase():
        self.nav.setRoot("RegisterPage");
        break;
      case "Existing Registration Sopra Not Verified Blocked".toUpperCase():
        self.nav.setRoot("RegHoldingPage");
        break;
      case "New Existing Mailer".toUpperCase():
      case "New Existing Mailer Send".toUpperCase():
      case "New Existing Mailer Drafted".toUpperCase():
      case "New Existing Forgot Mailer".toUpperCase():
        self.nav.setRoot("UniqueNewnumberPage");
        break;
      case "Existing Mailer".toUpperCase():
      case "Existing Mailer Drafted".toUpperCase():
      case "Existing Mailer Send".toUpperCase():
      case "Existing Registration Sopra Verified".toUpperCase():
        // self.nav.setRoot("UniquePassbookPage");
        break;
      case "Existing Registration Sopra Error".toUpperCase():
      case "Existing Registration Sopra Reattempt".toUpperCase():
        self.nav.setRoot("PassbookProcessingPage");
        break;
      case "New Existing Mailer Blocked".toUpperCase():
      case "New Customer Mailer Input Blocked".toUpperCase():
      case "Existing Mailer Blocked".toUpperCase():
        self.nav.setRoot("BlockedMailerPage");
        break
      case "New customer is Active PIN Verification".toUpperCase():
      case "New Active PIN Verification".toUpperCase():
      case "Active PIN Verification".toUpperCase():
      case "Existing Active PIN Verification".toUpperCase():
      case "New Existing Active PIN Verification".toUpperCase():
        self.nav.setRoot("ExistingPinPage");
        break;
      case "Active Blocked".toUpperCase():
      case "Existing Found Active Blocked".toUpperCase():
      case "New Existing Found Existing Blocked".toUpperCase():
      case "New Existing Found Active Blocked".toUpperCase():
      case "New Customer Found Active Blocked".toUpperCase():
      case "New Customer Found Existing Blocked".toUpperCase():
        self.nav.setRoot("ExistingBlockedPage");
        break;
      case "Active Set PIN".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "New Customer Application Approved".toUpperCase():
        //self.nav.setRoot("ScreenMessagePage");
        self.nav.setRoot("PayfundsToAccountsPage");
        break;
      case "New Customer Credit Check Failed".toUpperCase():
      case "New Customer Application Rejected".toUpperCase():
        self.nav.setRoot("AccountCreditcheckFailedPage");
        break;
      case "New Active Set PIN".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "Active PIN Verification Blocked".toUpperCase():
      case "Active Found Existing Blocked".toUpperCase():
      case "Active Found New Blocked".toUpperCase():
      case "Existing Active PIN Verification Blocked".toUpperCase():
      case "New Existing Active PIN Verification Blocked".toUpperCase():
      case "New Active PIN Verification Blocked".toUpperCase():
        self.nav.setRoot("ExisitngPinBlockedPage");
        break;
      case "New Customer Pay In Funds".toUpperCase():
        self.nav.setRoot("PayFundPage");
        break;
      case "New Customer Fund Account Details".toUpperCase():
        self.nav.setRoot("PayfundsToAccountsPage");
        break;
      case "New Customer Mailer".toUpperCase():
        self.nav.setRoot("SetPinPage");
        break;
      case "New Customer Mailer Input".toUpperCase():
      case "New Customer Mailer Drafted".toUpperCase():
      case "New Customer Mailer Send".toUpperCase():
      case "New Customer RPA Agent Error".toUpperCase():
      case "New Customer RPA Agent Reattempt".toUpperCase():
        self.nav.setRoot("UniqueReferencePage");
        break;
      case "Blocked".toUpperCase():
        self.nav.setRoot("LoginBlockedPage");
        break;
      case "Existing Forgot Pin Blocked".toUpperCase():
        self.nav.setRoot("ExistingBlockedPage");
        break;
      case "Existing Forgot Pin".toUpperCase():
        self.nav.setRoot("VerifyPinPage");
        break;
      case "Existing Reset Pin".toUpperCase():
        self.nav.setRoot("ResetPinPage");
        break;
      case undefined:
        self.nav.setRoot("HintPage");
        break;
      case "Existing Customer Personal Details".toUpperCase():
      case "Existing Customer Documents Verification Continue From Branch".toUpperCase():
      case "Existing Customer Verification Documents Confirmation Check".toUpperCase():
      case "Existing Customer Account Processing".toUpperCase():
        //self.nav.setRoot("TaxResidencyPage");
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Tax Residency".toUpperCase():
        //self.nav.setRoot("TaxResidencyPage");
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Rpa Agent Error".toUpperCase():
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Rpa Agent Reattempt".toUpperCase():
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Rpa Agent Failed".toUpperCase():
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Application Rejected".toUpperCase():
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Active".toUpperCase():
      case "New Existing Active".toUpperCase():
      case "New Customer Active".toUpperCase():
      case "Existing Customer Mailer Drafted".toUpperCase():
      case "Existing Customer Mailer Send".toUpperCase():
      case "active":
      case "Active":
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Customer Products Terms and Condition".toUpperCase():
        //self.nav.setRoot("ProductTermsConditionsPage")
        if (self.platform.is("core") || self.platform.is("mobileweb")) {
          self.nav.setRoot("LoginPage");
        } else {
          self.nav.setRoot("LoginFormPage");
        }
        break;
      case "Existing Logout".toUpperCase():
        self.nav.setRoot("LogoutPage");
        break;
      case "New Customer Application PEP Pause".toUpperCase():
      case "New Customer Application PEP Relative Pause".toUpperCase():
      case "New Customer Application Sanction Pause".toUpperCase():
      case "New Customer Application Pause Approved".toUpperCase():
      case "New Customer Application Pause Rejected".toUpperCase():
        self.nav.setRoot("NewcustomerpausePage");
        break;
      case "online new customer send otp".toUpperCase():
        // console.log("setting");
        // self.nav.setRoot("WebAccountTypePage", { process: "WEB_NRC1" });
        break;
      case "online new customer verified otp".toUpperCase():
        self.nav.setRoot("WebAccountTypePage", { process: "WEB_NRC1" });
        break;
      case "online new customer confirmed residency".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_CMN2", label: "WEB_CMN2" });
        break;
      case "online new customer agreed tnc".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR3", label: "WEB_NCR3" });
        break;
      case "online new customer product selected".toUpperCase():
        // console.log("settings page", this.settings.selectedProduct);

        if (this.settings.selectedProduct == "Junior Saver") {
          self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR10", label: "WEB_NCR10" });
        } else if (this.settings.selectedProduct == "Junior Cash ISA") {
          self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR10", label: "WEB_NCR10" });
        } else {
          // console.log("ncr6a");
          self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR6A", label: "WEB_NCR6A" });
        }
        break;
      case "online new customer regular frequency".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR6", label: "WEB_NCR6" });
        break;
      case "online new customer updated funds origin".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NRC7", label: "WEB_NRC7" });
        break;
      case "online new customer updated personal details".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NRC8", label: "WEB_NRC8" });
        break;
      case "online new customer updated address details".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NRC13", label: "WEB_NRC13" });
        break;
      case "online new customer updated nba details".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NRC14", label: "WEB_NRC14" });
        break;
      case "online new customer confirmed tax resident".toUpperCase():
        self.nav.setRoot("NewCustomerPage", { process: "WEB_NCR18", label: "WEB_NCR18" });
        break;
      default:
        // window.showNoStatus(self.settings.status);
        //self.nav.setRoot("HintPage");
        break;
    }
  }


  getproductinfo() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getProductinformation()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  postupdatemarketing(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updatemarketing(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  updatenominatedbankdetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updatenominatedbankdetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  updateaccountsdata(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateaccountsdata(data)
        .then((data) => {

          resolve(data);
        }).catch((err) => {

          reject(err);
        })
    })
  }
  getappVersion() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getAppVersion()
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(self.languageProvider.get("error loading demo data"));
        });
    })
  }
  getGenderTitle() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getGenderTitle()
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }

  getCountryList() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCountryList()
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }

  Complaintreplyisread(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.complaintreplyisread(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }

  setAddressverified(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setaddressverified(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }

  getSopraConfig() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getsopraconfig()
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }
  getMaileractive(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getmaileractive(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }

  sendFeedback(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendfeedback(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }
  getTokenSetting() {
    let self = this;
    let token = null;
    try {
      setTimeout(function () {
        window.FCMPlugin.getToken(function (data) {
          token = data;
          if (token == "" || token == null) {
            setTimeout(self.getTokenSetting.bind(self), 2000);
          } else {
            const updateDeviceTokenData = {
              modelname: self.device.model,
              uuid: self.device.uuid,
              devicetoken: token,
              devicetype: self.device.platform
            }
            if (self.settings.newAccountId !== "") {
              updateDeviceTokenData['new_accounts_id'] = self.settings.newAccountId;
            }
            if (self.settings.customerId !== "" && window.clientDemo) {
              updateDeviceTokenData['customers_id'] = self.settings.customerId;
            }
            //Register device token
            if (self.settings.token !== updateDeviceTokenData.devicetoken || window.clientDemo) {
              self.gateway.registerDeviceTokenNew(updateDeviceTokenData).then((result: any) => {
                self.settings.customer_devices_id = result.customer_devices_id;
                self.settings.token = updateDeviceTokenData.devicetoken;
                self.settings.devicetype = self.device.platform;
                self.setSettings(self.settings);
              }).catch((error) => {
                self.events.publish("consectus:500.error", error);
              })
            }
            return token;
          }
        });
      }, 3000)
    } catch (e) {
      return false;
    }
  }
  /////////////// two factor////
  twofactorauth(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.twofactorauth(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }
  verifytwofactor(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifytwofactor(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {

          reject(error);
        });
    })
  }
  /////////////// Save application status Online////////////////
  SaveApplicationStatusOnline(body: any) {
    let self = this;
    body = { ...body, settingsformdata: self.settings };
    return new Promise(function (resolve, reject) {
      self.gateway.SaveApplicationStatusOnline(body)
        .then((data) => {
          let alert = self.alertCtrl.create({
            title: "Application Saved",
            message: "Your application has been saved successfully",
            buttons: [
              {
                text: "Ok",
                role: 'Ok',
                handler: () => {
                }
              }
            ],
            enableBackdropDismiss: false
          });
          alert.present();
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }
  /////////////// Saved application number verification Online////////////////
  SavedApplicationNumberVerificationOnline(body) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.SavedApplicationNumberVerificationOnline(body)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        });
    })
  }
  /** Get All app setting Online **/
  getDataForOnlineSettingsPage() {
    let self = this;
    return new Promise(function (resolve, reject) {
      let custormer_id = {
        customers_id: self.settings.customerId
      }
      self.gateway.getSettingsOnline(custormer_id)
        .then((result: any) => {
          self.settings.userNumber = result.data[0].mobileno_user;
          //self.settings.userEmail = result.data[0].emailid_user;
          self.settings.userEmail = result.data[0].emailid_bank ? result.data[0].emailid_bank : result.data[0].emailid_user;
          self.settings.productInformation = result.data[0].marketingpreferences;
          self.settings.touchEnabled = result.data[0].istouchid;
          self.settings.external_notifications = result.data[0].thirdpartynotifications;
          self.settings.external_number = result.data[0].emerygencymobileno;
          self.settings.external_amount = result.data[0].maxamount;
          self.setSettings(self.settings).then(() => {
          })
          resolve(result)
        });
    });
  }
  /**
    * 
    * @param status 
    * @param checkStatus 
    */
  updateOnlineStatus(status) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let customerData = {
        new_accounts_id: self.settings.newAccountId,
        state_status: status
      };
      self.gateway.changeOnlineCustomerStatus(customerData).then((result: any) => {
        // self.settings.status = result.state_status;
        // self.getAllStatus();
        resolve(true);
      }).catch((err) => {
        reject(err)
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts